// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/images/poker/modal-bg-image.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/images/poker/tournaments/top-tournament-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/images/poker/tournaments/top-tournament-mobile-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/images/poker/tournaments/leaderboard-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/images/poker/game-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/images/poker/button-bg.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/images/poker/btn-border.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&family=Plus+Jakarta+Sans:wght@500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    --sidebar-bg: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);
    --logo-bg: #04102B;
    --text-bg: linear-gradient(90deg, #A5A5A5 0%, #C8C7C7 50%, #A5A5A5 100%);
    --timerBg: linear-gradient(180deg, #0E0F24 -1.96%, #161843 96.08%);
    --footerBg: rgba(19, 10, 36, 0.45);
    --sliderBg: linear-gradient(180deg, #B74ADE -34.9%, rgba(129, 48, 255, 0) 159.9%);
    --footerBorder: rgba(123, 44, 255, 0.2);
    --sidebarBorder: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);
    --timerBorder: linear-gradient(180deg, rgba(2, 97, 172, 0.2) -1.96%, rgba(129, 205, 246, 0.2) 103.92%);
    --sliderBorder: transparent;
    --rangeButton: linear-gradient(180deg, #3D0651 1.2%, #B84AE0 96.2%);
    --sliderWrapperBg: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 14.06%, rgba(0, 0, 0, 0) 85.94%, rgba(0, 0, 0, 0.6) 100%),
      linear-gradient(90deg, rgba(255, 255, 255, 0.01) 9.9%, rgba(255, 255, 255, 0.15) 51.04%, rgba(255, 255, 255, 0.01) 89.58%);
    --foldButtonBg: linear-gradient(90deg, #4C1D95 0%, #C026D3 100%);
    --checkButtonBg: linear-gradient(90deg, #5A3412 0%, #F4B942 100%);
    --BetButtonBg: linear-gradient(90deg, #2E1065 0%, #8B5CF6 100%);
    --callButtonBg: linear-gradient(90deg, #052E16 0%, #22C55E 100%);
    --raiseButtonBg: linear-gradient(90deg, #0B3A5B 0%, #38BDF8 100%);
    --allButtonBg: linear-gradient(90deg, #1E1B4B 0%, #818CF8 100%);
    --modalBg: linear-gradient(180deg, #0E0F31 49.51%, #161843 98.06%);
    --toggleBgOff: rgba(255, 255, 255, 0.24);
    --toggleBgOn: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);
    --toggleBorder: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);
    --tableBg: #040D20;
    --tableBorder: rgba(14, 89, 148, 0.4);
    --filterBg: #060822;
    --filterWrapperBg: #161843;
    --inputCheckButtonBg: linear-gradient(180deg, #045E8B -1.96%, #002D51 96.08%);
    --tournamentBorderColor: rgba(24, 188, 238, 0.2);
    --tournamentPodiumFrontCardBg: linear-gradient(180deg, #7B2CFF 0%, rgba(19, 10, 36, 0) 100%);
    --tournamentPodiumTopCardBg: linear-gradient(0deg, rgba(123, 44, 255, 0.75) 0%, rgba(123, 44, 255, 0.08) 100%);
    --modalBorder: #0D2B4D;
    --buyWith: #060822;
    --buyWithText: #A2A2A2;
    --modalBgImage: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    --tournamentBgImage: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    --tournamentMobileBgImage: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    --leaderboardBgImage: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    --sliderShadow: 0px 0px 5.39px 0px #FFFFFFCC inset;
    --actionButtonshadow: 0px 0px 8px 0px rgba(192, 38, 211, 0.4), 0px 7px 10px 0px #FFFFFF4D inset;
    --buyWithShadow: 0px 2px 4px 0px #030415 inset;
    --trophyDropShadow: 0 0 40px #18BCEE;
  }
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 375px){
  .\\!container{
    max-width: 375px !important;
  }
  .container{
    max-width: 375px;
  }
}
@media (min-width: 640px){
  .\\!container{
    max-width: 640px !important;
  }
  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){
  .\\!container{
    max-width: 768px !important;
  }
  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){
  .\\!container{
    max-width: 1024px !important;
  }
  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){
  .\\!container{
    max-width: 1280px !important;
  }
  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){
  .\\!container{
    max-width: 1536px !important;
  }
  .container{
    max-width: 1536px;
  }
}
@media (min-width: 1920px){
  .\\!container{
    max-width: 1920px !important;
  }
  .container{
    max-width: 1920px;
  }
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.-inset-x-0{
  left: -0px;
  right: -0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-right-1{
  right: -0.25rem;
}
.-top-1{
  top: -0.25rem;
}
.-top-14{
  top: -3.5rem;
}
.-top-2\\.5{
  top: -0.625rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-\\[-20px\\]{
  bottom: -20px;
}
.end-0{
  inset-inline-end: 0px;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-3{
  left: 0.75rem;
}
.left-\\[-56px\\]{
  left: -56px;
}
.right-0{
  right: 0px;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.top-0{
  top: 0px;
}
.top-1\\/2{
  top: 50%;
}
.top-2\\.5{
  top: 0.625rem;
}
.top-20{
  top: 5rem;
}
.top-\\[-43px\\]{
  top: -43px;
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-50{
  z-index: 50;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[2\\]{
  z-index: 2;
}
.z-\\[45\\]{
  z-index: 45;
}
.z-\\[60\\]{
  z-index: 60;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.float-end{
  float: inline-end;
}
.m-0{
  margin: 0px;
}
.m-auto{
  margin: auto;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}
.-mb-12{
  margin-bottom: -3rem;
}
.-mb-3{
  margin-bottom: -0.75rem;
}
.-mt-2{
  margin-top: -0.5rem;
}
.-mt-3{
  margin-top: -0.75rem;
}
.-mt-8{
  margin-top: -2rem;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.me-0{
  margin-inline-end: 0px;
}
.me-1\\.5{
  margin-inline-end: 0.375rem;
}
.me-2{
  margin-inline-end: 0.5rem;
}
.me-4{
  margin-inline-end: 1rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.mr-1{
  margin-right: 0.25rem;
}
.ms-0{
  margin-inline-start: 0px;
}
.ms-1{
  margin-inline-start: 0.25rem;
}
.ms-2{
  margin-inline-start: 0.5rem;
}
.ms-auto{
  margin-inline-start: auto;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.box-border{
  box-sizing: border-box;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.\\!table{
  display: table !important;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.list-item{
  display: list-item;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-28{
  height: 7rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-36{
  height: 9rem;
}
.h-4{
  height: 1rem;
}
.h-44{
  height: 11rem;
}
.h-5{
  height: 1.25rem;
}
.h-6{
  height: 1.5rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[2\\.6rem\\]{
  height: 2.6rem;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[4\\.5rem\\]{
  height: 4.5rem;
}
.h-\\[4\\.75rem\\]{
  height: 4.75rem;
}
.h-\\[51px\\]{
  height: 51px;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-8{
  max-height: 2rem;
}
.max-h-\\[1\\.0625rem\\]{
  max-height: 1.0625rem;
}
.max-h-\\[2\\.25rem\\]{
  max-height: 2.25rem;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-full{
  max-height: 100%;
}
.min-h-0{
  min-height: 0px;
}
.min-h-1{
  min-height: 0.25rem;
}
.min-h-10{
  min-height: 2.5rem;
}
.min-h-11{
  min-height: 2.75rem;
}
.min-h-5{
  min-height: 1.25rem;
}
.min-h-8{
  min-height: 2rem;
}
.min-h-9{
  min-height: 2.25rem;
}
.min-h-\\[1\\.0625rem\\]{
  min-height: 1.0625rem;
}
.min-h-\\[2\\.125rem\\]{
  min-height: 2.125rem;
}
.min-h-\\[2\\.25rem\\]{
  min-height: 2.25rem;
}
.min-h-\\[2rem\\]{
  min-height: 2rem;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.w-0\\.5{
  width: 0.125rem;
}
.w-1{
  width: 0.25rem;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-44{
  width: 11rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-6{
  width: 1.5rem;
}
.w-7{
  width: 1.75rem;
}
.w-8{
  width: 2rem;
}
.w-\\[130\\%\\]{
  width: 130%;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[4\\.5rem\\]{
  width: 4.5rem;
}
.w-\\[4\\.75rem\\]{
  width: 4.75rem;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[6\\.25rem\\]{
  width: 6.25rem;
}
.w-\\[7\\.25rem\\]{
  width: 7.25rem;
}
.w-\\[8\\.75rem\\]{
  width: 8.75rem;
}
.w-\\[9\\.75rem\\]{
  width: 9.75rem;
}
.w-\\[min\\(100\\%\\2c 17\\.5rem\\)\\]{
  width: min(100%, 17.5rem);
}
.w-\\[min\\(100\\%\\2c 20\\.5rem\\)\\]{
  width: min(100%, 20.5rem);
}
.w-\\[min\\(100\\%\\2c 20rem\\)\\]{
  width: min(100%, 20rem);
}
.w-\\[min\\(100\\%-2rem\\2c 24rem\\)\\]{
  width: min(100% - 2rem, 24rem);
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.min-w-0{
  min-width: 0px;
}
.min-w-24{
  min-width: 6rem;
}
.min-w-40{
  min-width: 10rem;
}
.min-w-\\[1\\.0625rem\\]{
  min-width: 1.0625rem;
}
.min-w-\\[12\\.5rem\\]{
  min-width: 12.5rem;
}
.min-w-\\[144px\\]{
  min-width: 144px;
}
.min-w-\\[2\\.25rem\\]{
  min-width: 2.25rem;
}
.min-w-\\[2rem\\]{
  min-width: 2rem;
}
.min-w-\\[36rem\\]{
  min-width: 36rem;
}
.min-w-\\[3ch\\]{
  min-width: 3ch;
}
.min-w-\\[3rem\\]{
  min-width: 3rem;
}
.min-w-\\[4\\.25ch\\]{
  min-width: 4.25ch;
}
.min-w-\\[4\\.5rem\\]{
  min-width: 4.5rem;
}
.min-w-\\[5\\.5rem\\]{
  min-width: 5.5rem;
}
.min-w-\\[64rem\\]{
  min-width: 64rem;
}
.min-w-\\[7\\.25rem\\]{
  min-width: 7.25rem;
}
.min-w-\\[8\\.75rem\\]{
  min-width: 8.75rem;
}
.min-w-full{
  min-width: 100%;
}
.max-w-48{
  max-width: 12rem;
}
.max-w-64{
  max-width: 16rem;
}
.max-w-72{
  max-width: 18rem;
}
.max-w-\\[1\\.0625rem\\]{
  max-width: 1.0625rem;
}
.max-w-\\[10\\.5rem\\]{
  max-width: 10.5rem;
}
.max-w-\\[2\\.25rem\\]{
  max-width: 2.25rem;
}
.max-w-\\[20rem\\]{
  max-width: 20rem;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[272px\\]{
  max-width: 272px;
}
.max-w-\\[458px\\]{
  max-width: 458px;
}
.max-w-\\[7\\.5rem\\]{
  max-width: 7.5rem;
}
.max-w-\\[721px\\]{
  max-width: 721px;
}
.max-w-\\[735px\\]{
  max-width: 735px;
}
.max-w-\\[9\\.5rem\\]{
  max-width: 9.5rem;
}
.max-w-full{
  max-width: 100%;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1;
}
.flex-\\[0_0_100\\%\\]{
  flex: 0 0 100%;
}
.flex-auto{
  flex: 1 1 auto;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-top{
  transform-origin: top;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-45deg\\]{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.72\\]{
  --tw-scale-x: 0.72;
  --tw-scale-y: 0.72;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform-gpu{
  transform: translate3d(var(--tw-translate-x), var(--tw-translate-y), 0) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes prize-amount-glow{
  0%, 100%{
    filter: drop-shadow(0 0 3px rgba(255, 234, 148, 0.22));
  }
  50%{
    filter: drop-shadow(0 0 7px rgba(255, 234, 148, 0.4));
  }
}
.animate-prize-amount-glow{
  animation: prize-amount-glow 3s ease-in-out infinite;
}
@keyframes prize-shine-wipe{
  0%{
    transform: translateX(-140%) skewX(-14deg);
  }
  100%{
    transform: translateX(340%) skewX(-14deg);
  }
}
.animate-prize-shine-wipe{
  animation: prize-shine-wipe 2.8s ease-in-out infinite;
}
@keyframes pulse{
  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
@keyframes timer-bounce-hard{
  0%, 100%{
    transform: translateY(0) scale(1);
  }
  50%{
    transform: translateY(-4px) scale(1.1);
  }
}
.animate-timer-bounce-hard{
  animation: timer-bounce-hard 0.4s ease-in-out infinite;
}
@keyframes timer-bounce-soft{
  0%, 100%{
    transform: translateY(0) scale(1);
  }
  50%{
    transform: translateY(-2px) scale(1.04);
  }
}
.animate-timer-bounce-soft{
  animation: timer-bounce-soft 0.85s ease-in-out infinite;
}
@keyframes timer-zoom{
  0%, 100%{
    transform: scale(1);
  }
  50%{
    transform: scale(1.05);
  }
}
.animate-timer-zoom{
  animation: timer-zoom 0.8s ease-in-out infinite;
}
@keyframes timer-zoom-critical{
  0%, 100%{
    transform: scale(1);
  }
  50%{
    transform: scale(1.12);
  }
}
.animate-timer-zoom-critical{
  animation: timer-zoom-critical 0.45s ease-in-out infinite;
}
@keyframes urgent-glow{
  0%, 100%{
    box-shadow: 0 0 4px 1px rgba(253, 181, 0, 0.3);
  }
  50%{
    box-shadow: 0 0 12px 4px rgba(253, 181, 0, 0.6);
  }
}
.animate-urgent-glow{
  animation: urgent-glow 0.8s ease-in-out infinite;
}
@keyframes urgent-glow-critical{
  0%, 100%{
    box-shadow: 0 0 4px 1px rgba(232, 13, 27, 0.35);
  }
  50%{
    box-shadow: 0 0 12px 4px rgba(232, 13, 27, 0.75);
  }
}
.animate-urgent-glow-critical{
  animation: urgent-glow-critical 0.45s ease-in-out infinite;
}
@keyframes urgent-pulse{
  0%, 100%{
    opacity: 1;
  }
  50%{
    opacity: 0.4;
  }
}
.animate-urgent-pulse{
  animation: urgent-pulse 0.8s ease-in-out infinite;
}
@keyframes urgent-pulse-critical{
  0%, 100%{
    opacity: 1;
  }
  50%{
    opacity: 0.25;
  }
}
.animate-urgent-pulse-critical{
  animation: urgent-pulse-critical 0.45s ease-in-out infinite;
}
@keyframes urgent-pulse-started{
  0%, 100%{
    opacity: 1;
  }
  50%{
    opacity: 0.4;
  }
}
.animate-urgent-pulse-started{
  animation: urgent-pulse-started 0.8s ease-in-out infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-help{
  cursor: help;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.touch-pan-x{
  --tw-pan-x: pan-x;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.touch-pan-y{
  --tw-pan-y: pan-y;
  touch-action: var(--tw-pan-x) var(--tw-pan-y) var(--tw-pinch-zoom);
}
.touch-manipulation{
  touch-action: manipulation;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize{
  resize: both;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-\\[minmax\\(4\\.5rem\\2c 0\\.7fr\\)_minmax\\(9rem\\2c 1\\.6fr\\)_minmax\\(4rem\\2c 0\\.7fr\\)_minmax\\(6rem\\2c 1fr\\)_minmax\\(5\\.5rem\\2c 0\\.8fr\\)\\]{
  grid-template-columns: minmax(4.5rem,0.7fr) minmax(9rem,1.6fr) minmax(4rem,0.7fr) minmax(6rem,1fr) minmax(5.5rem,0.8fr);
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-evenly{
  justify-content: space-evenly;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-\\[1px\\]{
  gap: 1px;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overflow-y-visible{
  overflow-y: visible;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.text-nowrap{
  text-wrap: nowrap;
}
.break-normal{
  overflow-wrap: normal;
  word-break: normal;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-\\[18px\\]{
  border-radius: 18px;
}
.rounded-\\[30px\\]{
  border-radius: 30px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-sm{
  border-bottom-right-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}
.rounded-t{
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-t{
  border-top-width: 1px;
}
.border-\\[\\#0D2B4D\\]{
  --tw-border-opacity: 1;
  border-color: rgb(13 43 77 / var(--tw-border-opacity, 1));
}
.border-\\[\\#18BCEE\\]\\/35{
  border-color: rgb(24 188 238 / 0.35);
}
.border-\\[\\#18BCEE\\]\\/60{
  border-color: rgb(24 188 238 / 0.6);
}
.border-\\[\\#27366A\\]{
  --tw-border-opacity: 1;
  border-color: rgb(39 54 106 / var(--tw-border-opacity, 1));
}
.border-\\[\\#34ADF1\\]{
  --tw-border-opacity: 1;
  border-color: rgb(52 173 241 / var(--tw-border-opacity, 1));
}
.border-\\[\\#34ADF1\\]\\/80{
  border-color: rgb(52 173 241 / 0.8);
}
.border-\\[\\#7A36F4\\]{
  --tw-border-opacity: 1;
  border-color: rgb(122 54 244 / var(--tw-border-opacity, 1));
}
.border-\\[\\#7A36F4\\]\\/80{
  border-color: rgb(122 54 244 / 0.8);
}
.border-\\[\\#7b2cff\\]\\/20{
  border-color: rgb(123 44 255 / 0.2);
}
.border-\\[\\#7b2cff\\]\\/25{
  border-color: rgb(123 44 255 / 0.25);
}
.border-\\[\\#7b2cff\\]\\/30{
  border-color: rgb(123 44 255 / 0.3);
}
.border-\\[\\#7b2cff\\]\\/35{
  border-color: rgb(123 44 255 / 0.35);
}
.border-\\[\\#83CF30\\]\\/40{
  border-color: rgb(131 207 48 / 0.4);
}
.border-\\[\\#8DBD51\\]{
  --tw-border-opacity: 1;
  border-color: rgb(141 189 81 / var(--tw-border-opacity, 1));
}
.border-\\[\\#8DBD51\\]\\/30{
  border-color: rgb(141 189 81 / 0.3);
}
.border-\\[\\#8DBD51\\]\\/80{
  border-color: rgb(141 189 81 / 0.8);
}
.border-\\[\\#D08A4E\\]\\/25{
  border-color: rgb(208 138 78 / 0.25);
}
.border-\\[\\#D08A4E\\]\\/40{
  border-color: rgb(208 138 78 / 0.4);
}
.border-\\[\\#E41532\\]{
  --tw-border-opacity: 1;
  border-color: rgb(228 21 50 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E41532\\]\\/80{
  border-color: rgb(228 21 50 / 0.8);
}
.border-\\[\\#EE952D\\]{
  --tw-border-opacity: 1;
  border-color: rgb(238 149 45 / var(--tw-border-opacity, 1));
}
.border-\\[\\#EE9C42\\]\\/35{
  border-color: rgb(238 156 66 / 0.35);
}
.border-\\[\\#F5A623\\]\\/40{
  border-color: rgb(245 166 35 / 0.4);
}
.border-\\[\\#F5C542\\]\\/25{
  border-color: rgb(245 197 66 / 0.25);
}
.border-\\[\\#F5C542\\]\\/40{
  border-color: rgb(245 197 66 / 0.4);
}
.border-\\[\\#c45cff\\]\\/40{
  border-color: rgb(196 92 255 / 0.4);
}
.border-\\[\\#c45cff\\]\\/70{
  border-color: rgb(196 92 255 / 0.7);
}
.border-amber-400\\/40{
  border-color: rgb(251 191 36 / 0.4);
}
.border-amber-400\\/45{
  border-color: rgb(251 191 36 / 0.45);
}
.border-black{
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-cyan-400\\/40{
  border-color: rgb(34 211 238 / 0.4);
}
.border-footerBorder{
  border-color: var(--footerBorder);
}
.border-gray-500{
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}
.border-modalBorder{
  border-color: var(--modalBorder);
}
.border-red-400\\/40{
  border-color: rgb(248 113 113 / 0.4);
}
.border-tableBorder{
  border-color: var(--tableBorder);
}
.border-transparent{
  border-color: transparent;
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/\\[0\\.06\\]{
  border-color: rgb(255 255 255 / 0.06);
}
.border-white\\/\\[0\\.08\\]{
  border-color: rgb(255 255 255 / 0.08);
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#050621\\]\\/80{
  background-color: rgb(5 6 33 / 0.8);
}
.bg-\\[\\#050621\\]\\/90{
  background-color: rgb(5 6 33 / 0.9);
}
.bg-\\[\\#06030d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(6 3 13 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#080D20\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(8 13 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#090f1d\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(9 15 29 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0B1024\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 16 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#100D23\\]\\/95{
  background-color: rgb(16 13 35 / 0.95);
}
.bg-\\[\\#110c23\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(17 12 35 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#130a24\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(19 10 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#181428\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 20 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#18BCEE\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 188 238 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1f2e\\]\\/90{
  background-color: rgb(26 31 46 / 0.9);
}
.bg-\\[\\#1b1033\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(27 16 51 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2a1a0a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(42 26 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#34ADF1\\]\\/10{
  background-color: rgb(52 173 241 / 0.1);
}
.bg-\\[\\#4B4DED33\\]{
  background-color: #4B4DED33;
}
.bg-\\[\\#7A36F4\\]\\/10{
  background-color: rgb(122 54 244 / 0.1);
}
.bg-\\[\\#7b2cff\\]\\/35{
  background-color: rgb(123 44 255 / 0.35);
}
.bg-\\[\\#83CF30\\]\\/15{
  background-color: rgb(131 207 48 / 0.15);
}
.bg-\\[\\#8DBD51\\]\\/10{
  background-color: rgb(141 189 81 / 0.1);
}
.bg-\\[\\#C45CFF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(196 92 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#D08A4E\\]\\/10{
  background-color: rgb(208 138 78 / 0.1);
}
.bg-\\[\\#D08A4E\\]\\/15{
  background-color: rgb(208 138 78 / 0.15);
}
.bg-\\[\\#E41532\\]\\/10{
  background-color: rgb(228 21 50 / 0.1);
}
.bg-\\[\\#EE952D\\]\\/10{
  background-color: rgb(238 149 45 / 0.1);
}
.bg-\\[\\#F5C542\\]\\/15{
  background-color: rgb(245 197 66 / 0.15);
}
.bg-\\[\\#b04cfc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(176 76 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c45cff\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(196 92 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#c45cff\\]\\/10{
  background-color: rgb(196 92 255 / 0.1);
}
.bg-\\[\\#c45cff\\]\\/15{
  background-color: rgb(196 92 255 / 0.15);
}
.bg-\\[\\#c45cff\\]\\/25{
  background-color: rgb(196 92 255 / 0.25);
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/75{
  background-color: rgb(0 0 0 / 0.75);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-cyan-600{
  --tw-bg-opacity: 1;
  background-color: rgb(8 145 178 / var(--tw-bg-opacity, 1));
}
.bg-filterBg{
  background-color: var(--filterBg);
}
.bg-footerBg{
  background-color: var(--footerBg);
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-950{
  --tw-bg-opacity: 1;
  background-color: rgb(3 7 18 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-lime-600{
  --tw-bg-opacity: 1;
  background-color: rgb(101 163 13 / var(--tw-bg-opacity, 1));
}
.bg-logoBg{
  background-color: var(--logo-bg);
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-600{
  --tw-bg-opacity: 1;
  background-color: rgb(219 39 119 / var(--tw-bg-opacity, 1));
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/80{
  background-color: rgb(239 68 68 / 0.8);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-red-800{
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/35{
  background-color: rgb(255 255 255 / 0.35);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06);
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-BetButtonBg{
  background-image: var(--BetButtonBg);
}
.bg-\\[linear-gradient\\(180deg\\2c \\#3D0651_1\\.2\\%\\2c \\#130A24_96\\.2\\%\\)\\]{
  background-image: linear-gradient(180deg,#3D0651 1.2%,#130A24 96.2%);
}
.bg-\\[linear-gradient\\(180deg\\2c \\#8BB8E8_0\\%\\2c \\#6A4AD8_100\\%\\)\\]{
  background-image: linear-gradient(180deg,#8BB8E8 0%,#6A4AD8 100%);
}
.bg-\\[linear-gradient\\(180deg\\2c \\#B548DC_-1\\.96\\%\\2c \\#56146E_96\\.08\\%\\)\\]{
  background-image: linear-gradient(180deg,#B548DC -1.96%,#56146E 96.08%);
}
.bg-\\[linear-gradient\\(180deg\\2c rgba\\(232\\2c 13\\2c 27\\2c 0\\.55\\)_-1\\.96\\%\\2c rgba\\(255\\2c 91\\2c 103\\2c 0\\.65\\)_103\\.92\\%\\)\\]{
  background-image: linear-gradient(180deg,rgba(232,13,27,0.55) -1.96%,rgba(255,91,103,0.65) 103.92%);
}
.bg-\\[linear-gradient\\(180deg\\2c rgba\\(253\\2c 181\\2c 0\\2c 0\\.45\\)_-1\\.96\\%\\2c rgba\\(255\\2c 234\\2c 148\\2c 0\\.55\\)_103\\.92\\%\\)\\]{
  background-image: linear-gradient(180deg,rgba(253,181,0,0.45) -1.96%,rgba(255,234,148,0.55) 103.92%);
}
.bg-\\[linear-gradient\\(90deg\\2c \\#4C1D95_0\\%\\2c \\#C026D3_100\\%\\)\\]{
  background-image: linear-gradient(90deg,#4C1D95 0%,#C026D3 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c \\#7B2CFF_0\\%\\2c \\#C45CFF_100\\%\\)\\]{
  background-image: linear-gradient(90deg,#7B2CFF 0%,#C45CFF 100%);
}
.bg-allButtonBg{
  background-image: var(--allButtonBg);
}
.bg-callButtonBg{
  background-image: var(--callButtonBg);
}
.bg-checkButtonBg{
  background-image: var(--checkButtonBg);
}
.bg-foldButtonBg{
  background-image: var(--foldButtonBg);
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-leaderboardBgImage{
  background-image: var(--leaderboardBgImage);
}
.bg-modalBg{
  background-image: var(--modalBg);
}
.bg-modalBgImage{
  background-image: var(--modalBgImage);
}
.bg-raiseButtonBg{
  background-image: var(--raiseButtonBg);
}
.bg-rangeButton{
  background-image: var(--rangeButton);
}
.bg-sliderBg{
  background-image: var(--sliderBg);
}
.bg-sliderBorder{
  background-image: var(--sliderBorder);
}
.bg-sliderWrapperBg{
  background-image: var(--sliderWrapperBg);
}
.bg-textBg{
  background-image: var(--text-bg);
}
.bg-timerBorder{
  background-image: var(--timerBorder);
}
.bg-tournamentPodiumFrontCardBg{
  background-image: var(--tournamentPodiumFrontCardBg);
}
.bg-tournamentPodiumTopCardBg{
  background-image: var(--tournamentPodiumTopCardBg);
}
.from-\\[\\#0f1a12\\]\\/85{
  --tw-gradient-from: rgb(15 26 18 / 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(15 26 18 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#2a1f0a\\]\\/70{
  --tw-gradient-from: rgb(42 31 10 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(42 31 10 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#2a1f0a\\]\\/75{
  --tw-gradient-from: rgb(42 31 10 / 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(42 31 10 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#7B8BA8\\]{
  --tw-gradient-from: #7B8BA8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(123 139 168 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#7b2cff\\]{
  --tw-gradient-from: #7b2cff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(123 44 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#C12B34\\]{
  --tw-gradient-from: #C12B34 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(193 43 52 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#C47A4A\\]{
  --tw-gradient-from: #C47A4A var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(196 122 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#F5A623\\]{
  --tw-gradient-from: #F5A623 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 166 35 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#100D23\\]{
  --tw-gradient-to: rgb(16 13 35 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #100D23 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#100D23\\]\\/95{
  --tw-gradient-to: rgb(16 13 35 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(16 13 35 / 0.95) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#F5A623\\]\\/60{
  --tw-gradient-to: rgb(245 166 35 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(245 166 35 / 0.6) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#c45cff\\]\\/70{
  --tw-gradient-to: rgb(196 92 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(196 92 255 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/75{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.75) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0B1A3A\\]{
  --tw-gradient-to: #0B1A3A var(--tw-gradient-to-position);
}
.to-\\[\\#0f1a12\\]\\/85{
  --tw-gradient-to: rgb(15 26 18 / 0.85) var(--tw-gradient-to-position);
}
.to-\\[\\#2a1f0a\\]\\/75{
  --tw-gradient-to: rgb(42 31 10 / 0.75) var(--tw-gradient-to-position);
}
.to-\\[\\#C12B34\\]{
  --tw-gradient-to: #C12B34 var(--tw-gradient-to-position);
}
.to-\\[\\#C5CEDD\\]{
  --tw-gradient-to: #C5CEDD var(--tw-gradient-to-position);
}
.to-\\[\\#E8B089\\]{
  --tw-gradient-to: #E8B089 var(--tw-gradient-to-position);
}
.to-\\[\\#FFE08A\\]{
  --tw-gradient-to: #FFE08A var(--tw-gradient-to-position);
}
.to-\\[\\#c45cff\\]{
  --tw-gradient-to: #c45cff var(--tw-gradient-to-position);
}
.to-\\[\\#c45cff\\]\\/50{
  --tw-gradient-to: rgb(196 92 255 / 0.5) var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-\\[length\\:100\\%\\]{
  background-size: 100%;
}
.bg-auto{
  background-size: auto;
}
.bg-cover{
  background-size: cover;
}
.bg-clip-text{
  background-clip: text;
}
.bg-center{
  background-position: center;
}
.bg-top{
  background-position: top;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.p-\\[26px\\]{
  padding: 26px;
}
.p-\\[2px\\]{
  padding: 2px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5{
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-\\[\\.1875rem\\]{
  padding-top: .1875rem;
  padding-bottom: .1875rem;
}
.py-\\[1\\.125rem\\]{
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
}
.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-4{
  padding-bottom: 1rem;
}
.pe-10{
  padding-inline-end: 2.5rem;
}
.pe-2{
  padding-inline-end: 0.5rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.ps-2{
  padding-inline-start: 0.5rem;
}
.ps-8{
  padding-inline-start: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-baseline{
  vertical-align: baseline;
}
.font-\\[Inter\\2c sans-serif\\]{
  font-family: Inter,sans-serif;
}
.font-bebas{
  font-family: "Bebas Neue", sans-serif;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.\\!text-xl{
  font-size: 1.25rem !important;
  line-height: 1.75rem !important;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-\\[0\\.4375rem\\]{
  font-size: 0.4375rem;
}
.text-\\[0\\.55rem\\]{
  font-size: 0.55rem;
}
.text-\\[0\\.5rem\\]{
  font-size: 0.5rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[17px\\]{
  line-height: 17px;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.02em\\]{
  letter-spacing: 0.02em;
}
.tracking-\\[0\\.04em\\]{
  letter-spacing: 0.04em;
}
.tracking-\\[0\\.06em\\]{
  letter-spacing: 0.06em;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.16em\\]{
  letter-spacing: 0.16em;
}
.tracking-\\[0\\.22em\\]{
  letter-spacing: 0.22em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.text-\\[\\#140820\\]{
  --tw-text-opacity: 1;
  color: rgb(20 8 32 / var(--tw-text-opacity, 1));
}
.text-\\[\\#18BCEE\\]{
  --tw-text-opacity: 1;
  color: rgb(24 188 238 / var(--tw-text-opacity, 1));
}
.text-\\[\\#34ADF1\\]{
  --tw-text-opacity: 1;
  color: rgb(52 173 241 / var(--tw-text-opacity, 1));
}
.text-\\[\\#66739B\\]{
  --tw-text-opacity: 1;
  color: rgb(102 115 155 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7A36F4\\]{
  --tw-text-opacity: 1;
  color: rgb(122 54 244 / var(--tw-text-opacity, 1));
}
.text-\\[\\#7DD3FC\\]{
  --tw-text-opacity: 1;
  color: rgb(125 211 252 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8230fe\\]{
  --tw-text-opacity: 1;
  color: rgb(130 48 254 / var(--tw-text-opacity, 1));
}
.text-\\[\\#83CF30\\]{
  --tw-text-opacity: 1;
  color: rgb(131 207 48 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8A92A6\\]{
  --tw-text-opacity: 1;
  color: rgb(138 146 166 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8DBD51\\]{
  --tw-text-opacity: 1;
  color: rgb(141 189 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8c8494\\]{
  --tw-text-opacity: 1;
  color: rgb(140 132 148 / var(--tw-text-opacity, 1));
}
.text-\\[\\#93A0C4\\]{
  --tw-text-opacity: 1;
  color: rgb(147 160 196 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A2A2A2\\]{
  --tw-text-opacity: 1;
  color: rgb(162 162 162 / var(--tw-text-opacity, 1));
}
.text-\\[\\#D0D7E4\\]{
  --tw-text-opacity: 1;
  color: rgb(208 215 228 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E41532\\]{
  --tw-text-opacity: 1;
  color: rgb(228 21 50 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E8B089\\]{
  --tw-text-opacity: 1;
  color: rgb(232 176 137 / var(--tw-text-opacity, 1));
}
.text-\\[\\#EE952D\\]{
  --tw-text-opacity: 1;
  color: rgb(238 149 45 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F3B04A\\]{
  --tw-text-opacity: 1;
  color: rgb(243 176 74 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F4B942\\]{
  --tw-text-opacity: 1;
  color: rgb(244 185 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F5C542\\]{
  --tw-text-opacity: 1;
  color: rgb(245 197 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F6D7B0\\]{
  --tw-text-opacity: 1;
  color: rgb(246 215 176 / var(--tw-text-opacity, 1));
}
.text-\\[\\#F95B76\\]{
  --tw-text-opacity: 1;
  color: rgb(249 91 118 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FDB500\\]{
  --tw-text-opacity: 1;
  color: rgb(253 181 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF5B67\\]{
  --tw-text-opacity: 1;
  color: rgb(255 91 103 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFE08A\\]{
  --tw-text-opacity: 1;
  color: rgb(255 224 138 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFEA94\\]{
  --tw-text-opacity: 1;
  color: rgb(255 234 148 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c45cff\\]{
  --tw-text-opacity: 1;
  color: rgb(196 92 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c4b5fd\\]{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-buyWithText{
  color: var(--buyWithText);
}
.text-cyan-200{
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.text-cyan-300{
  --tw-text-opacity: 1;
  color: rgb(103 232 249 / var(--tw-text-opacity, 1));
}
.text-cyan-400{
  --tw-text-opacity: 1;
  color: rgb(34 211 238 / var(--tw-text-opacity, 1));
}
.text-cyan-400\\/80{
  color: rgb(34 211 238 / 0.8);
}
.text-filterBg{
  color: var(--filterBg);
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-red-200{
  --tw-text-opacity: 1;
  color: rgb(254 202 202 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.opacity-40{
  opacity: 0.4;
}
.opacity-45{
  opacity: 0.45;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow-\\[0_0_0_1px_rgba\\(22\\2c 24\\2c 67\\2c 0\\.9\\)\\]{
  --tw-shadow: 0 0 0 1px rgba(22,24,67,0.9);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(192\\2c 38\\2c 211\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 0 10px rgba(192,38,211,0.4);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(245\\2c 166\\2c 35\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 0 10px rgba(245,166,35,0.12);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgba\\(253\\2c 181\\2c 0\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 0 10px rgba(253,181,0,0.35);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_12px_rgba\\(232\\2c 13\\2c 27\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 0 12px rgba(232,13,27,0.45);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_16px_rgba\\(123\\2c 44\\2c 255\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 0 16px rgba(123,44,255,0.45);
  --tw-shadow-colored: 0 0 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(131\\2c 207\\2c 48\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 0 8px rgba(131,207,48,0.12);
  --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_rgba\\(123\\2c 44\\2c 255\\2c 0\\.18\\)\\]{
  --tw-shadow: 0 12px 40px rgba(123,44,255,0.18);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_rgba\\(123\\2c 44\\2c 255\\2c 0\\.22\\)\\]{
  --tw-shadow: 0 12px 40px rgba(123,44,255,0.22);
  --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_40px_80px_rgba\\(128\\2c 48\\2c 254\\2c 0\\.12\\)\\]{
  --tw-shadow: 0 40px 80px rgba(128,48,254,0.12);
  --tw-shadow-colored: 0 40px 80px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_24px_64px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.72\\)\\]{
  --tw-shadow: 0px 24px 64px -12px rgba(0,0,0,0.72);
  --tw-shadow-colored: 0px 24px 64px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0px_4px_16px_rgba\\(123\\2c 44\\2c 255\\2c 0\\.4\\)\\]{
  --tw-shadow: 0px 4px 16px rgba(123,44,255,0.4);
  --tw-shadow-colored: 0px 4px 16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-actionButtonshadow{
  --tw-shadow: var(--actionButtonshadow);
  --tw-shadow-colored: var(--actionButtonshadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sliderShadow{
  --tw-shadow: var(--sliderShadow);
  --tw-shadow-colored: var(--sliderShadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[\\#18BCEE\\]\\/10{
  --tw-shadow-color: rgb(24 188 238 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-amber-500\\/10{
  --tw-shadow-color: rgb(245 158 11 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\]{
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_10px_rgba\\(245\\2c 166\\2c 35\\2c 0\\.3\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 10px rgba(245,166,35,0.3));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_12px_rgba\\(245\\2c 166\\2c 35\\2c 0\\.35\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 12px rgba(245,166,35,0.35));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_18px_rgba\\(196\\2c 92\\2c 255\\2c 0\\.55\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 18px rgba(196,92,255,0.55));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_22px_rgba\\(196\\2c 92\\2c 255\\2c 0\\.5\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 22px rgba(196,92,255,0.5));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_0_40px_rgba\\(196\\2c 92\\2c 255\\2c 0\\.45\\)\\]{
  --tw-drop-shadow: drop-shadow(0 0 40px rgba(196,92,255,0.45));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[5px\\]{
  --tw-backdrop-blur: blur(5px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c background\\]{
  transition-property: box-shadow,background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-linear{
  transition-timing-function: linear;
}
  body {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
  }
  .footer-section .timer button {
    font-family: Nunito Sans;
  }
  .footer-section .button-group {
    flex-wrap: wrap;
  }
  .footer-section .button-group button {
    font-size: clamp(14px, 1.093dvw, 1.1rem);
    line-height: 22px;
    min-width: 140px;
    width: fit-content;
  }
  .footer-section .button-group button.bg-foldButtonBg {
    box-shadow: 0px 0px 8px rgba(192, 38, 211, 0.4), inset 0px 7px 10px rgba(255, 255, 255, 0.3019607843);
  }
  .footer-section .button-group button.bg-checkButtonBg {
    box-shadow: 0px 0px 8px rgba(244, 185, 66, 0.4), inset 0px 7px 10px rgba(255, 255, 255, 0.3019607843);
  }
  .footer-section .button-group button.bg-BetButtonBg {
    box-shadow: 0px 0px 8px rgba(139, 92, 246, 0.4), inset 0px 7px 10px rgba(255, 255, 255, 0.3019607843);
  }
  .footer-section .button-group button.bg-callButtonBg {
    box-shadow: 0px 0px 8px rgba(34, 197, 94, 0.4), inset 0px 7px 10px rgba(255, 255, 255, 0.3019607843);
  }
  .footer-section .button-group button.bg-raiseButtonBg {
    box-shadow: 0px 0px 8px rgba(56, 189, 248, 0.4), inset 0px 7px 10px rgba(255, 255, 255, 0.3019607843);
  }
  .footer-section .button-group button.bg-allButtonBg {
    box-shadow: 0px 0px 8px rgba(129, 140, 248, 0.4), inset 0px 7px 10px rgba(255, 255, 255, 0.3019607843);
  }
  @media screen and (max-width: 1024px) {
    .footer-section .button-group button {
      min-width: 84px;
      font-size: clamp(12px, 1.093dvw, 14px);
      line-height: 14px;
    }
  }
  .footer-section .range-slider-input.slider::-webkit-slider-thumb {
    background: linear-gradient(180deg, #3D0651 1.2%, #B84AE0 96.2%);
  }
  .footer-section .range-slider-input.slider::-moz-range-thumb {
    background: linear-gradient(180deg, #3D0651 1.2%, #B84AE0 96.2%);
  }
  .landing-logo-btn {
    display: inline-flex;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
    line-height: 0;
  }
  .landing-logo-btn img,
  .game-rules-header__logo {
    display: block;
    height: var(--ufe-logo-height);
    width: auto;
    max-width: none;
  }
  .ufe-game-header {
    position: absolute;
    top: var(--ufe-logo-top);
    left: var(--ufe-logo-inset);
    right: var(--ufe-logo-inset);
    z-index: 10;
    pointer-events: none;
  }
  .leave-table-btn,
  .v2-exit-table {
    box-sizing: border-box;
    mask-image: none !important;
    -webkit-mask-image: none !important;
    aspect-ratio: auto;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 6px !important;
    position: relative;
    height: 45px;
    min-height: 45px;
    padding: 8px 16px;
    border: 1px solid rgba(123, 44, 255, 0.2) !important;
    border-radius: 6px !important;
    background: #130a24 !important;
    color: #ffffff !important;
    font-family: "Nunito Sans", sans-serif !important;
    font-size: 13px !important;
    font-weight: 700 !important;
    font-style: normal;
    line-height: 18px !important;
    word-break: normal;
    white-space: nowrap;
    outline: none;
    box-shadow: none !important;
  }
  .leave-table-btn:before,
  .v2-exit-table:before {
    display: none;
  }
  .leave-table-btn svg,
  .v2-exit-table svg {
    width: 13.5px;
    height: 13.5px;
    display: block;
    flex: none;
    color: #ffffff;
  }
  .leave-table-btn:hover, .leave-table-btn:focus, .leave-table-btn:active,
  .v2-exit-table:hover,
  .v2-exit-table:focus,
  .v2-exit-table:active {
    border-color: rgba(123, 44, 255, 0.2) !important;
    background: #130a24 !important;
    outline: none;
    box-shadow: none !important;
  }
  .v2-exit-table {
    display: inline-flex;
    width: 111.5px;
    cursor: pointer;
  }
  .v2-exit-table:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
  .v2-music-btn {
    mask-image: none !important;
    -webkit-mask-image: none !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    min-height: 45px;
    padding: 0;
    border: 1px solid rgba(123, 44, 255, 0.2) !important;
    border-radius: 6px !important;
    background: #130a24 !important;
    color: #ffffff !important;
    box-shadow: none !important;
  }
  .v2-music-btn svg {
    width: 13.5px;
    height: 13.5px;
  }
  .action-btn {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background: linear-gradient(180deg, #0E0F24 -1.96%, #161843 96.08%);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-size: 100% 100%;
    background-clip: padding-box;
    word-break: break-all;
    position: relative;
    aspect-ratio: 48/17;
    font-size: clamp(12px, 1.093dvw, 16px);
  }
  .action-btn:before {
    content: "";
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    position: absolute;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background: linear-gradient(180deg, rgba(2, 97, 172, 0.2) -1.96%, rgba(129, 205, 246, 0.2) 103.92%);
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% 100%;
    mask-repeat: no-repeat;
    mask-size: 100% 100%;
    background-clip: padding-box;
  }
  .action-btn:nth-child(1) {
    background: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);
  }
  .action-btn:nth-child(1):before {
    background: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);
  }
  .\\!container {
    max-width: 1716px !important;
    margin: 0 auto !important;
    width: 100% !important;
  }
  .container {
    max-width: 1716px;
    margin: 0 auto;
    width: 100%;
  }
  @media screen and (max-width: 767px) {
    .\\!container {
      max-width: 100% !important;
    }
    .container {
      max-width: 100%;
    }
  }
.\\[-webkit-text-stroke\\:0\\.5px_\\#DEDEDE\\]{
  -webkit-text-stroke: 0.5px #DEDEDE;
}
:root {
  --ufe-logo-height: 28px;
  --ufe-logo-top: 32px;
  --ufe-logo-inset: 64px;
}

@media (max-width: 767.98px) {
  :root {
    --ufe-logo-inset: 20px;
  }
}
* {
  font-family: "Nunito Sans", sans-serif;
}
body #root {
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
}
body .Toastify__toast-theme--colored.Toastify__toast--success {
  background: #04102B;
  box-shadow: 0px -1px 11px 0px #2883C8 inset;
  border: 1px solid rgba(40, 131, 200, 0.6);
  border-radius: 1rem;
  padding-left: 1.3125rem;
}
body .Toastify__toast-theme--colored.Toastify__toast--error {
  background: rgb(193, 43, 52);
  box-shadow: 0px -1px 11px 0px #C12B34 inset;
  border: 1px solid rgba(193, 43, 52, 0.6);
  border-radius: 1rem;
  padding-left: 1.3125rem;
}
body .Toastify__close-button--colored {
  display: none;
}
body .themed-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #2570AE rgba(14, 89, 148, 0.18);
}
body .themed-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
body .themed-scrollbar::-webkit-scrollbar-track {
  background: rgba(14, 89, 148, 0.18);
  border-radius: 9999px;
}
body .themed-scrollbar::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);
  border-radius: 9999px;
}
body .themed-scrollbar::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #81CDF6 -1.96%, #0B5691 96.08%);
}
body .modal-heading {
  background: linear-gradient(90deg, #FFFFFF 0%, #999999 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
  -webkit-text-stroke: 0.4px #DEDEDE;
  text-stroke: 0.4px #DEDEDE;
  font-size: 36px;
  font-weight: 400;
  line-height: normal;
}
@media screen and (max-width: 1024px) {
  body .modal-heading {
    font-size: 22px;
  }
}
@media screen and (max-width: 1279px) and (orientation: landscape) {
  body .modal-heading {
    font-size: 18px;
  }
}

@media screen and (max-width: 1023px) {
  .ufe-game-shell .leave-table-btn,
  .ufe-game-shell .v2-exit-table {
    height: 26px;
    min-height: 26px;
    padding: 2px 8px;
    font-size: 11px !important;
    line-height: 14px !important;
    gap: 4px !important;
  }
  .ufe-game-shell .v2-exit-table {
    width: auto;
  }
  .ufe-game-shell .v2-music-btn {
    width: 26px;
    height: 26px;
    min-height: 26px;
  }
  .ufe-game-shell .leave-table-btn svg,
  .ufe-game-shell .v2-exit-table svg,
  .ufe-game-shell .v2-music-btn svg {
    width: 12px;
    height: 12px;
  }
  .ufe-game-shell .ufe-game-header .gap-4 {
    gap: 6px;
  }
}
@media screen and (max-height: 560px) {
  .ufe-game-shell {
    --ufe-logo-height: 18px;
    --ufe-logo-top: 6px;
    --ufe-logo-inset: 8px;
    padding-left: 8px !important;
    padding-right: 8px !important;
    padding-bottom: 8px !important;
  }
  .ufe-game-shell .leave-table-btn,
  .ufe-game-shell .v2-exit-table {
    height: 26px;
    min-height: 26px;
    padding: 2px 8px;
    font-size: 11px !important;
    line-height: 14px !important;
    gap: 4px !important;
  }
  .ufe-game-shell .v2-exit-table {
    width: auto;
  }
  .ufe-game-shell .v2-music-btn {
    width: 26px;
    height: 26px;
    min-height: 26px;
  }
  .ufe-game-shell .leave-table-btn svg,
  .ufe-game-shell .v2-exit-table svg,
  .ufe-game-shell .v2-music-btn svg {
    width: 12px;
    height: 12px;
  }
  .ufe-game-shell .ufe-game-header .gap-4 {
    gap: 6px;
  }
  .ufe-game-shell .landing-logo-btn img {
    width: auto;
    height: auto;
    max-height: 18px;
    max-width: 96px;
  }
  .ufe-game-shell .ufe-game-header .pointer-events-auto > .flex {
    align-items: center;
    gap: 4px;
    min-width: 0;
  }
  .ufe-game-shell .ufe-game-header .top-full {
    margin-top: 2px !important;
  }
  .ufe-game-shell .ufe-pool-details {
    gap: 3px !important;
    font-size: 8px !important;
    line-height: 1.15;
  }
  .ufe-game-shell #pixi-container {
    margin-top: 36px;
    margin-bottom: 52px;
  }
  .ufe-game-shell > .absolute {
    bottom: 6px !important;
    left: 8px !important;
    right: 8px !important;
  }
  .ufe-game-shell .footer-section {
    padding: 4px 6px !important;
    gap: 6px !important;
  }
  .ufe-game-shell .footer-section .button-group {
    flex-wrap: nowrap;
  }
  .ufe-game-shell .footer-section .button-group button {
    min-width: 0;
    min-height: 32px !important;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px !important;
    line-height: 14px !important;
  }
}
@media screen and (max-width: 767.98px) {
  .ufe-game-shell {
    --ufe-logo-height: 18px;
    --ufe-logo-top: 6px;
    --ufe-logo-inset: 8px;
    padding-left: 8px !important;
    padding-right: 8px !important;
    padding-bottom: 8px !important;
  }
  .ufe-game-shell .landing-logo-btn img {
    width: auto;
    height: auto;
    max-height: 18px;
    max-width: 96px;
  }
  .ufe-game-shell .ufe-game-header .pointer-events-auto > .flex {
    align-items: center;
    gap: 4px;
    min-width: 0;
  }
  .ufe-game-shell .ufe-game-header .top-full {
    margin-top: 2px !important;
  }
  .ufe-game-shell .ufe-pool-details {
    gap: 3px !important;
    font-size: 8px !important;
    line-height: 1.15;
  }
  .ufe-game-shell #pixi-container {
    margin-top: 36px;
    margin-bottom: 52px;
  }
  .ufe-game-shell > .absolute {
    bottom: 6px !important;
    left: 8px !important;
    right: 8px !important;
  }
  .ufe-game-shell .footer-section {
    padding: 4px 6px !important;
    gap: 6px !important;
  }
  .ufe-game-shell .footer-section .button-group {
    flex-wrap: nowrap;
  }
  .ufe-game-shell .footer-section .button-group button {
    min-width: 0;
    min-height: 32px !important;
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px !important;
    line-height: 14px !important;
  }
}
.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}
.hover\\:border-\\[\\#34ADF1\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(52 173 241 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#8DBD51\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(141 189 81 / var(--tw-border-opacity, 1));
}
.hover\\:bg-\\[\\#12215C\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(18 33 92 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-\\[\\#34ADF1\\]\\/20:hover{
  background-color: rgb(52 173 241 / 0.2);
}
.hover\\:bg-\\[\\#8DBD51\\]\\/20:hover{
  background-color: rgb(141 189 81 / 0.2);
}
.hover\\:bg-\\[\\#c064ff\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(192 100 255 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-black\\/40:hover{
  background-color: rgb(0 0 0 / 0.4);
}
.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-900:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(127 29 29 / var(--tw-bg-opacity, 1));
}
.hover\\:text-amber-200:hover{
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}
.hover\\:text-cyan-200:hover{
  --tw-text-opacity: 1;
  color: rgb(165 243 252 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:opacity-90:hover{
  opacity: 0.9;
}
.focus\\:border-b-red-800:focus{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(153 27 27 / var(--tw-border-opacity, 1));
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}
.disabled\\:hover\\:opacity-50:hover:disabled{
  opacity: 0.5;
}
.peer:checked ~ .peer-checked\\:translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:bg-red-700{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}
.peer:checked ~ .peer-checked\\:bg-red-800{
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity, 1));
}
@media not all and (min-width: 1280px){
  .max-xl\\:min-h-\\[2rem\\]{
    min-height: 2rem;
  }
  .max-xl\\:scroll-pe-3{
    scroll-padding-inline-end: 0.75rem;
  }
  .max-xl\\:scroll-ps-1{
    scroll-padding-inline-start: 0.25rem;
  }
  .max-xl\\:flex-nowrap{
    flex-wrap: nowrap;
  }
  .max-xl\\:overflow-x-auto{
    overflow-x: auto;
  }
  .max-xl\\:overflow-x-visible{
    overflow-x: visible;
  }
  .max-xl\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }
  .max-xl\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .max-xl\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .max-xl\\:pb-1\\.5{
    padding-bottom: 0.375rem;
  }
  .max-xl\\:pb-10{
    padding-bottom: 2.5rem;
  }
  .max-xl\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media not all and (min-width: 1024px){
  .max-lg\\:absolute{
    position: absolute;
  }
  .max-lg\\:left-6{
    left: 1.5rem;
  }
  .max-lg\\:top-6{
    top: 1.5rem;
  }
  .max-lg\\:mb-4{
    margin-bottom: 1rem;
  }
  .max-lg\\:\\!text-white{
    --tw-text-opacity: 1 !important;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
  }
}
@media (min-width: 640px){
  .sm\\:-top-3{
    top: -0.75rem;
  }
  .sm\\:top-6{
    top: 1.5rem;
  }
  .sm\\:-mt-4{
    margin-top: -1rem;
  }
  .sm\\:mb-5{
    margin-bottom: 1.25rem;
  }
  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .sm\\:mb-7{
    margin-bottom: 1.75rem;
  }
  .sm\\:mb-8{
    margin-bottom: 2rem;
  }
  .sm\\:mt-1{
    margin-top: 0.25rem;
  }
  .sm\\:mt-4{
    margin-top: 1rem;
  }
  .sm\\:mt-5{
    margin-top: 1.25rem;
  }
  .sm\\:mt-8{
    margin-top: 2rem;
  }
  .sm\\:h-10{
    height: 2.5rem;
  }
  .sm\\:h-12{
    height: 3rem;
  }
  .sm\\:h-14{
    height: 3.5rem;
  }
  .sm\\:h-16{
    height: 4rem;
  }
  .sm\\:h-20{
    height: 5rem;
  }
  .sm\\:h-24{
    height: 6rem;
  }
  .sm\\:h-28{
    height: 7rem;
  }
  .sm\\:h-36{
    height: 9rem;
  }
  .sm\\:h-40{
    height: 10rem;
  }
  .sm\\:h-48{
    height: 12rem;
  }
  .sm\\:h-6{
    height: 1.5rem;
  }
  .sm\\:h-7{
    height: 1.75rem;
  }
  .sm\\:w-10{
    width: 2.5rem;
  }
  .sm\\:w-12{
    width: 3rem;
  }
  .sm\\:w-14{
    width: 3.5rem;
  }
  .sm\\:w-16{
    width: 4rem;
  }
  .sm\\:w-20{
    width: 5rem;
  }
  .sm\\:w-24{
    width: 6rem;
  }
  .sm\\:w-28{
    width: 7rem;
  }
  .sm\\:w-40{
    width: 10rem;
  }
  .sm\\:w-7{
    width: 1.75rem;
  }
  .sm\\:w-\\[22rem\\]{
    width: 22rem;
  }
  .sm\\:w-full{
    width: 100%;
  }
  .sm\\:max-w-\\[50\\%\\]{
    max-width: 50%;
  }
  .sm\\:max-w-\\[85\\%\\]{
    max-width: 85%;
  }
  .sm\\:max-w-none{
    max-width: none;
  }
  .sm\\:max-w-sm{
    max-width: 24rem;
  }
  .sm\\:flex-row{
    flex-direction: row;
  }
  .sm\\:items-center{
    align-items: center;
  }
  .sm\\:gap-3{
    gap: 0.75rem;
  }
  .sm\\:gap-4{
    gap: 1rem;
  }
  .sm\\:rounded-2xl{
    border-radius: 1rem;
  }
  .sm\\:p-4{
    padding: 1rem;
  }
  .sm\\:p-5{
    padding: 1.25rem;
  }
  .sm\\:px-2\\.5{
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .sm\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .sm\\:py-3\\.5{
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
  }
  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .sm\\:pt-5{
    padding-top: 1.25rem;
  }
  .sm\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }
  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }
  .sm\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }
  .sm\\:text-\\[10px\\]{
    font-size: 10px;
  }
  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }
  .sm\\:text-\\[36px\\]{
    font-size: 36px;
  }
  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .sm\\:leading-\\[44px\\]{
    line-height: 44px;
  }
  .sm\\:leading-relaxed{
    line-height: 1.625;
  }
  .sm\\:tracking-\\[0\\.14em\\]{
    letter-spacing: 0.14em;
  }
  .sm\\:shadow-2xl{
    --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
    --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (min-width: 768px){
  .md\\:h-14{
    height: 3.5rem;
  }
  .md\\:h-8{
    height: 2rem;
  }
  .md\\:w-14{
    width: 3.5rem;
  }
  .md\\:w-8{
    width: 2rem;
  }
  .md\\:max-w-md{
    max-width: 28rem;
  }
  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .md\\:text-\\[11px\\]{
    font-size: 11px;
  }
  .md\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  @media not all and (min-width: 1280px){
    .md\\:max-xl\\:min-h-\\[2\\.5rem\\]{
      min-height: 2.5rem;
    }
    .md\\:max-xl\\:px-5{
      padding-left: 1.25rem;
      padding-right: 1.25rem;
    }
    .md\\:max-xl\\:py-2{
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .md\\:max-xl\\:text-sm{
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
  }
}
@media (min-width: 1024px){
  .lg\\:static{
    position: static;
  }
  .lg\\:relative{
    position: relative;
  }
  .lg\\:left-9{
    left: 2.25rem;
  }
  .lg\\:right-9{
    right: 2.25rem;
  }
  .lg\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .lg\\:-mt-2{
    margin-top: -0.5rem;
  }
  .lg\\:-mt-8{
    margin-top: -2rem;
  }
  .lg\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .lg\\:mb-3{
    margin-bottom: 0.75rem;
  }
  .lg\\:mb-5{
    margin-bottom: 1.25rem;
  }
  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }
  .lg\\:block{
    display: block;
  }
  .lg\\:flex{
    display: flex;
  }
  .lg\\:hidden{
    display: none;
  }
  .lg\\:h-10{
    height: 2.5rem;
  }
  .lg\\:h-12{
    height: 3rem;
  }
  .lg\\:h-14{
    height: 3.5rem;
  }
  .lg\\:h-20{
    height: 5rem;
  }
  .lg\\:h-44{
    height: 11rem;
  }
  .lg\\:h-5{
    height: 1.25rem;
  }
  .lg\\:h-56{
    height: 14rem;
  }
  .lg\\:h-8{
    height: 2rem;
  }
  .lg\\:h-9{
    height: 2.25rem;
  }
  .lg\\:h-auto{
    height: auto;
  }
  .lg\\:max-h-72{
    max-height: 18rem;
  }
  .lg\\:min-h-0{
    min-height: 0px;
  }
  .lg\\:min-h-\\[4\\.25rem\\]{
    min-height: 4.25rem;
  }
  .lg\\:w-10{
    width: 2.5rem;
  }
  .lg\\:w-12{
    width: 3rem;
  }
  .lg\\:w-14{
    width: 3.5rem;
  }
  .lg\\:w-20{
    width: 5rem;
  }
  .lg\\:w-5{
    width: 1.25rem;
  }
  .lg\\:w-8{
    width: 2rem;
  }
  .lg\\:w-9{
    width: 2.25rem;
  }
  .lg\\:w-\\[calc\\(20\\%-9\\.6px\\)\\]{
    width: calc(20% - 9.6px);
  }
  .lg\\:w-auto{
    width: auto;
  }
  .lg\\:w-full{
    width: 100%;
  }
  .lg\\:min-w-0{
    min-width: 0px;
  }
  .lg\\:min-w-40{
    min-width: 10rem;
  }
  .lg\\:min-w-48{
    min-width: 12rem;
  }
  .lg\\:max-w-24{
    max-width: 6rem;
  }
  .lg\\:max-w-48{
    max-width: 12rem;
  }
  .lg\\:max-w-60{
    max-width: 15rem;
  }
  .lg\\:max-w-\\[378px\\]{
    max-width: 378px;
  }
  .lg\\:max-w-\\[80\\%\\]{
    max-width: 80%;
  }
  .lg\\:max-w-\\[9rem\\]{
    max-width: 9rem;
  }
  .lg\\:translate-x-0{
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:scale-100{
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
  .lg\\:flex-row{
    flex-direction: row;
  }
  .lg\\:flex-wrap{
    flex-wrap: wrap;
  }
  .lg\\:items-center{
    align-items: center;
  }
  .lg\\:gap-1\\.5{
    gap: 0.375rem;
  }
  .lg\\:gap-3{
    gap: 0.75rem;
  }
  .lg\\:gap-4{
    gap: 1rem;
  }
  .lg\\:gap-7{
    gap: 1.75rem;
  }
  .lg\\:overflow-visible{
    overflow: visible;
  }
  .lg\\:rounded-xl{
    border-radius: 0.75rem;
  }
  .lg\\:p-2{
    padding: 0.5rem;
  }
  .lg\\:p-2\\.5{
    padding: 0.625rem;
  }
  .lg\\:p-4{
    padding: 1rem;
  }
  .lg\\:p-5{
    padding: 1.25rem;
  }
  .lg\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .lg\\:px-3\\.5{
    padding-left: 0.875rem;
    padding-right: 0.875rem;
  }
  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .lg\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .lg\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .lg\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .lg\\:py-1\\.5{
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .lg\\:py-2\\.5{
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .lg\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .lg\\:pb-0{
    padding-bottom: 0px;
  }
  .lg\\:pe-4{
    padding-inline-end: 1rem;
  }
  .lg\\:ps-12{
    padding-inline-start: 3rem;
  }
  .lg\\:\\!text-\\[36px\\]{
    font-size: 36px !important;
  }
  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .lg\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }
  .lg\\:text-\\[10px\\]{
    font-size: 10px;
  }
  .lg\\:text-\\[11px\\]{
    font-size: 11px;
  }
  .lg\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .lg\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .lg\\:leading-relaxed{
    line-height: 1.625;
  }
  .lg\\:tracking-\\[0\\.08em\\]{
    letter-spacing: 0.08em;
  }
}
@media (min-width: 1280px){
  .xl\\:-top-11{
    top: -2.75rem;
  }
  .xl\\:-mt-16{
    margin-top: -4rem;
  }
  .xl\\:mb-2{
    margin-bottom: 0.5rem;
  }
  .xl\\:block{
    display: block;
  }
  .xl\\:flex{
    display: flex;
  }
  .xl\\:hidden{
    display: none;
  }
  .xl\\:h-5{
    height: 1.25rem;
  }
  .xl\\:h-6{
    height: 1.5rem;
  }
  .xl\\:h-\\[65px\\]{
    height: 65px;
  }
  .xl\\:max-h-\\[2\\.25rem\\]{
    max-height: 2.25rem;
  }
  .xl\\:max-h-none{
    max-height: none;
  }
  .xl\\:min-h-0{
    min-height: 0px;
  }
  .xl\\:min-h-14{
    min-height: 3.5rem;
  }
  .xl\\:min-h-\\[2\\.25rem\\]{
    min-height: 2.25rem;
  }
  .xl\\:w-5{
    width: 1.25rem;
  }
  .xl\\:w-6{
    width: 1.5rem;
  }
  .xl\\:w-\\[15\\.375rem\\]{
    width: 15.375rem;
  }
  .xl\\:w-\\[65px\\]{
    width: 65px;
  }
  .xl\\:w-full{
    width: 100%;
  }
  .xl\\:min-w-80{
    min-width: 20rem;
  }
  .xl\\:min-w-\\[2\\.25rem\\]{
    min-width: 2.25rem;
  }
  .xl\\:max-w-52{
    max-width: 13rem;
  }
  .xl\\:max-w-80{
    max-width: 20rem;
  }
  .xl\\:max-w-\\[2\\.25rem\\]{
    max-width: 2.25rem;
  }
  .xl\\:gap-2{
    gap: 0.5rem;
  }
  .xl\\:rounded-xl{
    border-radius: 0.75rem;
  }
  .xl\\:p-0{
    padding: 0px;
  }
  .xl\\:p-2{
    padding: 0.5rem;
  }
  .xl\\:p-3{
    padding: 0.75rem;
  }
  .xl\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .xl\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .xl\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .xl\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .xl\\:py-\\[1\\.125rem\\]{
    padding-top: 1.125rem;
    padding-bottom: 1.125rem;
  }
  .xl\\:pt-7{
    padding-top: 1.75rem;
  }
  .xl\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .xl\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .xl\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  .xl\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media not all and (min-width: 1280px){
  @media (orientation: landscape){
    .max-xl\\:landscape\\:-top-2{
      top: -0.5rem;
    }
    .max-xl\\:landscape\\:my-0\\.5{
      margin-top: 0.125rem;
      margin-bottom: 0.125rem;
    }
    .max-xl\\:landscape\\:my-1\\.5{
      margin-top: 0.375rem;
      margin-bottom: 0.375rem;
    }
    .max-xl\\:landscape\\:mb-0\\.5{
      margin-bottom: 0.125rem;
    }
    .max-xl\\:landscape\\:mb-1\\.5{
      margin-bottom: 0.375rem;
    }
    .max-xl\\:landscape\\:mb-2{
      margin-bottom: 0.5rem;
    }
    .max-xl\\:landscape\\:mb-2\\.5{
      margin-bottom: 0.625rem;
    }
    .max-xl\\:landscape\\:mb-3{
      margin-bottom: 0.75rem;
    }
    .max-xl\\:landscape\\:mt-0\\.5{
      margin-top: 0.125rem;
    }
    .max-xl\\:landscape\\:mt-1{
      margin-top: 0.25rem;
    }
    .max-xl\\:landscape\\:mt-1\\.5{
      margin-top: 0.375rem;
    }
    .max-xl\\:landscape\\:mt-2{
      margin-top: 0.5rem;
    }
    .max-xl\\:landscape\\:mt-3{
      margin-top: 0.75rem;
    }
    .max-xl\\:landscape\\:h-11{
      height: 2.75rem;
    }
    .max-xl\\:landscape\\:h-12{
      height: 3rem;
    }
    .max-xl\\:landscape\\:h-14{
      height: 3.5rem;
    }
    .max-xl\\:landscape\\:h-2{
      height: 0.5rem;
    }
    .max-xl\\:landscape\\:h-24{
      height: 6rem;
    }
    .max-xl\\:landscape\\:h-4{
      height: 1rem;
    }
    .max-xl\\:landscape\\:h-6{
      height: 1.5rem;
    }
    .max-xl\\:landscape\\:h-8{
      height: 2rem;
    }
    .max-xl\\:landscape\\:h-9{
      height: 2.25rem;
    }
    .max-xl\\:landscape\\:max-h-40{
      max-height: 10rem;
    }
    .max-xl\\:landscape\\:max-h-\\[85dvh\\]{
      max-height: 85dvh;
    }
    .max-xl\\:landscape\\:max-h-\\[min\\(85dvh\\2c 22rem\\)\\]{
      max-height: min(85dvh, 22rem);
    }
    .max-xl\\:landscape\\:min-h-8{
      min-height: 2rem;
    }
    .max-xl\\:landscape\\:min-h-\\[2rem\\]{
      min-height: 2rem;
    }
    .max-xl\\:landscape\\:w-11{
      width: 2.75rem;
    }
    .max-xl\\:landscape\\:w-12{
      width: 3rem;
    }
    .max-xl\\:landscape\\:w-14{
      width: 3.5rem;
    }
    .max-xl\\:landscape\\:w-2{
      width: 0.5rem;
    }
    .max-xl\\:landscape\\:w-24{
      width: 6rem;
    }
    .max-xl\\:landscape\\:w-4{
      width: 1rem;
    }
    .max-xl\\:landscape\\:w-6{
      width: 1.5rem;
    }
    .max-xl\\:landscape\\:w-7{
      width: 1.75rem;
    }
    .max-xl\\:landscape\\:w-8{
      width: 2rem;
    }
    .max-xl\\:landscape\\:w-9{
      width: 2.25rem;
    }
    .max-xl\\:landscape\\:w-\\[6\\.75rem\\]{
      width: 6.75rem;
    }
    .max-xl\\:landscape\\:w-\\[7\\.5rem\\]{
      width: 7.5rem;
    }
    .max-xl\\:landscape\\:w-\\[min\\(100\\%\\2c 17rem\\)\\]{
      width: min(100%, 17rem);
    }
    .max-xl\\:landscape\\:w-\\[min\\(100\\%-0\\.5rem\\2c 17\\.5rem\\)\\]{
      width: min(100% - 0.5rem, 17.5rem);
    }
    .max-xl\\:landscape\\:w-\\[min\\(16\\.25rem\\2c calc\\(100\\%-1rem\\)\\)\\]{
      width: min(16.25rem, calc(100% - 1rem));
    }
    .max-xl\\:landscape\\:w-\\[min\\(17\\.25rem\\2c calc\\(100\\%-1\\.25rem\\)\\)\\]{
      width: min(17.25rem, calc(100% - 1.25rem));
    }
    .max-xl\\:landscape\\:w-\\[min\\(calc\\(100\\%-0\\.75rem\\)\\2c 32rem\\)\\]{
      width: min(calc(100% - 0.75rem), 32rem);
    }
    .max-xl\\:landscape\\:min-w-\\[6\\.75rem\\]{
      min-width: 6.75rem;
    }
    .max-xl\\:landscape\\:min-w-\\[7\\.5rem\\]{
      min-width: 7.5rem;
    }
    .max-xl\\:landscape\\:min-w-\\[7rem\\]{
      min-width: 7rem;
    }
    .max-xl\\:landscape\\:max-w-\\[17rem\\]{
      max-width: 17rem;
    }
    .max-xl\\:landscape\\:max-w-\\[32rem\\]{
      max-width: 32rem;
    }
    .max-xl\\:landscape\\:max-w-\\[75\\%\\]{
      max-width: 75%;
    }
    .max-xl\\:landscape\\:max-w-full{
      max-width: 100%;
    }
    .max-xl\\:landscape\\:flex-row{
      flex-direction: row;
    }
    .max-xl\\:landscape\\:items-center{
      align-items: center;
    }
    .max-xl\\:landscape\\:gap-1{
      gap: 0.25rem;
    }
    .max-xl\\:landscape\\:gap-1\\.5{
      gap: 0.375rem;
    }
    .max-xl\\:landscape\\:gap-2{
      gap: 0.5rem;
    }
    .max-xl\\:landscape\\:rounded-xl{
      border-radius: 0.75rem;
    }
    .max-xl\\:landscape\\:bg-\\[length\\:100\\%_auto\\]{
      background-size: 100% auto;
    }
    .max-xl\\:landscape\\:p-1\\.5{
      padding: 0.375rem;
    }
    .max-xl\\:landscape\\:p-2{
      padding: 0.5rem;
    }
    .max-xl\\:landscape\\:p-2\\.5{
      padding: 0.625rem;
    }
    .max-xl\\:landscape\\:p-3{
      padding: 0.75rem;
    }
    .max-xl\\:landscape\\:px-0\\.5{
      padding-left: 0.125rem;
      padding-right: 0.125rem;
    }
    .max-xl\\:landscape\\:px-1\\.5{
      padding-left: 0.375rem;
      padding-right: 0.375rem;
    }
    .max-xl\\:landscape\\:px-2{
      padding-left: 0.5rem;
      padding-right: 0.5rem;
    }
    .max-xl\\:landscape\\:px-2\\.5{
      padding-left: 0.625rem;
      padding-right: 0.625rem;
    }
    .max-xl\\:landscape\\:px-3{
      padding-left: 0.75rem;
      padding-right: 0.75rem;
    }
    .max-xl\\:landscape\\:px-4{
      padding-left: 1rem;
      padding-right: 1rem;
    }
    .max-xl\\:landscape\\:py-1{
      padding-top: 0.25rem;
      padding-bottom: 0.25rem;
    }
    .max-xl\\:landscape\\:py-1\\.5{
      padding-top: 0.375rem;
      padding-bottom: 0.375rem;
    }
    .max-xl\\:landscape\\:py-2{
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
    }
    .max-xl\\:landscape\\:py-2\\.5{
      padding-top: 0.625rem;
      padding-bottom: 0.625rem;
    }
    .max-xl\\:landscape\\:py-4{
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
    .max-xl\\:landscape\\:pb-6{
      padding-bottom: 1.5rem;
    }
    .max-xl\\:landscape\\:ps-7{
      padding-inline-start: 1.75rem;
    }
    .max-xl\\:landscape\\:pt-10{
      padding-top: 2.5rem;
    }
    .max-xl\\:landscape\\:pt-3{
      padding-top: 0.75rem;
    }
    .max-xl\\:landscape\\:\\!text-lg{
      font-size: 1.125rem !important;
      line-height: 1.75rem !important;
    }
    .max-xl\\:landscape\\:\\!text-sm{
      font-size: 0.875rem !important;
      line-height: 1.25rem !important;
    }
    .max-xl\\:landscape\\:text-2xl{
      font-size: 1.5rem;
      line-height: 2rem;
    }
    .max-xl\\:landscape\\:text-4xl{
      font-size: 2.25rem;
      line-height: 2.5rem;
    }
    .max-xl\\:landscape\\:text-\\[0\\.6875rem\\]{
      font-size: 0.6875rem;
    }
    .max-xl\\:landscape\\:text-\\[10px\\]{
      font-size: 10px;
    }
    .max-xl\\:landscape\\:text-\\[11px\\]{
      font-size: 11px;
    }
    .max-xl\\:landscape\\:text-\\[8px\\]{
      font-size: 8px;
    }
    .max-xl\\:landscape\\:text-\\[9px\\]{
      font-size: 9px;
    }
    .max-xl\\:landscape\\:text-base{
      font-size: 1rem;
      line-height: 1.5rem;
    }
    .max-xl\\:landscape\\:text-lg{
      font-size: 1.125rem;
      line-height: 1.75rem;
    }
    .max-xl\\:landscape\\:text-xs{
      font-size: 0.75rem;
      line-height: 1rem;
    }
    .max-xl\\:landscape\\:leading-normal{
      line-height: 1.5;
    }
    .max-xl\\:landscape\\:leading-snug{
      line-height: 1.375;
    }
    .max-xl\\:landscape\\:leading-tight{
      line-height: 1.25;
    }
    .max-xl\\:landscape\\:tracking-\\[0\\.16em\\]{
      letter-spacing: 0.16em;
    }
  }
}
@media not all and (min-width: 1024px){
  @media (orientation: landscape){
    .max-lg\\:landscape\\:w-\\[32\\%\\]{
      width: 32%;
    }
  }
}
@media (min-width: 768px){
  @media not all and (min-width: 1280px){
    @media (orientation: landscape){
      .md\\:max-xl\\:landscape\\:min-h-\\[2\\.5rem\\]{
        min-height: 2.5rem;
      }
      .md\\:max-xl\\:landscape\\:text-sm{
        font-size: 0.875rem;
        line-height: 1.25rem;
      }
    }
  }
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:h-\\[22px\\]::-moz-range-thumb{
  height: 22px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:w-\\[31px\\]::-moz-range-thumb{
  width: 31px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:appearance-none::-moz-range-thumb{
  appearance: none;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:rounded-full::-moz-range-thumb{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:border-0::-moz-range-thumb{
  border-width: 0px;
}
.\\[\\&\\:\\:-moz-range-thumb\\]\\:bg-\\[linear-gradient\\(180deg\\2c \\#3D0651_1\\.2\\%\\2c \\#B84AE0_96\\.2\\%\\)\\]::-moz-range-thumb{
  background-image: linear-gradient(180deg,#3D0651 1.2%,#B84AE0 96.2%);
}
.\\[\\&\\:\\:-moz-range-track\\]\\:appearance-none::-moz-range-track{
  appearance: none;
}
.\\[\\&\\:\\:-ms-thumb\\]\\:appearance-none::-ms-thumb{
  appearance: none;
}
.\\[\\&\\:\\:-ms-track\\]\\:appearance-none::-ms-track{
  appearance: none;
}
.\\[\\&\\:\\:-webkit-slider-runnable-track\\]\\:appearance-none::-webkit-slider-runnable-track{
  appearance: none;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-6::-webkit-slider-thumb{
  height: 1.5rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-8::-webkit-slider-thumb{
  height: 2rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-\\[22px\\]::-webkit-slider-thumb{
  height: 22px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-6::-webkit-slider-thumb{
  width: 1.5rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-8::-webkit-slider-thumb{
  width: 2rem;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-\\[31px\\]::-webkit-slider-thumb{
  width: 31px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:appearance-none::-webkit-slider-thumb{
  appearance: none;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:rounded-full::-webkit-slider-thumb{
  border-radius: 9999px;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-green-500::-webkit-slider-thumb{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-\\[linear-gradient\\(180deg\\2c \\#3D0651_1\\.2\\%\\2c \\#B84AE0_96\\.2\\%\\)\\]::-webkit-slider-thumb{
  background-image: linear-gradient(180deg,#3D0651 1.2%,#B84AE0 96.2%);
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-cover::-webkit-slider-thumb{
  background-size: cover;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-center::-webkit-slider-thumb{
  background-position: center;
}
.\\[\\&\\:\\:-webkit-slider-thumb\\]\\:bg-no-repeat::-webkit-slider-thumb{
  background-repeat: no-repeat;
}
@media (min-width: 640px){
  .sm\\:\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-8::-webkit-slider-thumb{
    height: 2rem;
  }
  .sm\\:\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-8::-webkit-slider-thumb{
    width: 2rem;
  }
}
@media not all and (min-width: 1280px){
  @media (orientation: landscape){
    .max-xl\\:landscape\\:\\[\\&\\:\\:-webkit-slider-thumb\\]\\:h-4::-webkit-slider-thumb{
      height: 1rem;
    }
    .max-xl\\:landscape\\:\\[\\&\\:\\:-webkit-slider-thumb\\]\\:w-4::-webkit-slider-thumb{
      width: 1rem;
    }
  }
}
.\\[\\&\\>button\\:first-child\\]\\:rounded-s-lg>button:first-child{
  border-start-start-radius: 0.5rem;
  border-end-start-radius: 0.5rem;
}
.\\[\\&\\>button\\:last-child\\]\\:rounded-e-lg>button:last-child{
  border-start-end-radius: 0.5rem;
  border-end-end-radius: 0.5rem;
}
.\\[\\&_canvas\\]\\:block canvas{
  display: block;
}
.\\[\\&_canvas\\]\\:max-h-full canvas{
  max-height: 100%;
}
.\\[\\&_canvas\\]\\:max-w-full canvas{
  max-width: 100%;
}
.\\[\\&_canvas\\]\\:touch-none canvas{
  touch-action: none;
}
@media not all and (min-width: 1280px){
  @media (orientation: landscape){
    .\\[\\&_img\\]\\:max-xl\\:landscape\\:max-h-8 img{
      max-height: 2rem;
    }
    .\\[\\&_img\\]\\:max-xl\\:landscape\\:w-auto img{
      width: auto;
    }
  }
}
@media(max-height:520px){
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!top-1\\.5{
    top: 0.375rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!-mb-5{
    margin-bottom: -1.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!-mt-1{
    margin-top: -0.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!mb-1\\.5{
    margin-bottom: 0.375rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!mb-2{
    margin-bottom: 0.5rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!mt-0{
    margin-top: 0px !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!mt-0\\.5{
    margin-top: 0.125rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!mt-1{
    margin-top: 0.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!mt-2{
    margin-top: 0.5rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-16{
    height: 4rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-2{
    height: 0.5rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-20{
    height: 5rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-3{
    height: 0.75rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-6{
    height: 1.5rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-7{
    height: 1.75rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-8{
    height: 2rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!h-9{
    height: 2.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!w-12{
    width: 3rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!w-14{
    width: 3.5rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!w-3{
    width: 0.75rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!w-7{
    width: 1.75rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!w-8{
    width: 2rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!w-9{
    width: 2.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!max-w-\\[9rem\\]{
    max-width: 9rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!items-end{
    align-items: flex-end !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!gap-1{
    gap: 0.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!gap-1\\.5{
    gap: 0.375rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!px-1\\.5{
    padding-left: 0.375rem !important;
    padding-right: 0.375rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!py-0\\.5{
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!pb-1{
    padding-bottom: 0.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!text-\\[10px\\]{
    font-size: 10px !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!text-\\[11px\\]{
    font-size: 11px !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!text-\\[9px\\]{
    font-size: 9px !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!text-sm{
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!text-xs{
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }
  .\\[\\@media\\(max-height\\:520px\\)\\]\\:\\!leading-none{
    line-height: 1 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,cAAA;EAAA,cAAA;EAAA,cAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,aAAA;EAAA,kBAAA;EAAA,sCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,eAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,kBAAA;EAAA,2BAAA;EAAA,4BAAA;EAAA,sCAAA;EAAA,kCAAA;EAAA,2BAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA,YAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,cAAA;EAAA,gBAAA;EAAA,aAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,2BAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,yBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;;CAAA,CAAA;;;CAAA;;AAAA;;;EAAA,sBAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,mBAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;EAAA,gBAAA;AAAA;;AAAA;;;;;;;;CAAA;;AAAA;;EAAA,gBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA,EAAA,MAAA;EAAA,WAAA,EAAA,MAAA;EAAA,+HAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,wCAAA,EAAA,MAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,SAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,iCAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;EAAA,kBAAA;EAAA,oBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,mBAAA;AAAA;;AAAA;;;;;CAAA;;AAAA;;;;EAAA,+GAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,+BAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,cAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,cAAA;EAAA,cAAA;EAAA,kBAAA;EAAA,wBAAA;AAAA;;AAAA;EAAA,eAAA;AAAA;;AAAA;EAAA,WAAA;AAAA;;AAAA;;;;CAAA;;AAAA;EAAA,cAAA,EAAA,MAAA;EAAA,qBAAA,EAAA,MAAA;EAAA,yBAAA,EAAA,MAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;EAAA,oBAAA,EAAA,MAAA;EAAA,8BAAA,EAAA,MAAA;EAAA,gCAAA,EAAA,MAAA;EAAA,eAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;EAAA,uBAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;EAAA,SAAA,EAAA,MAAA;EAAA,UAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,oBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;;;EAAA,0BAAA,EAAA,MAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,aAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,YAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,6BAAA,EAAA,MAAA;EAAA,oBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,wBAAA;AAAA;;AAAA;;;CAAA;;AAAA;EAAA,0BAAA,EAAA,MAAA;EAAA,aAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,kBAAA;AAAA;;AAAA;;CAAA;;AAAA;;;;;;;;;;;;;EAAA,SAAA;AAAA;;AAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;EAAA,UAAA;AAAA;;AAAA;;;EAAA,gBAAA;EAAA,SAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,UAAA;AAAA;;AAAA;;CAAA;;AAAA;EAAA,gBAAA;AAAA;;AAAA;;;CAAA;;AAAA;;EAAA,UAAA,EAAA,MAAA;EAAA,cAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;AAAA;;AAAA;;CAAA;AAAA;EAAA,eAAA;AAAA;;AAAA;;;;CAAA;;AAAA;;;;;;;;EAAA,cAAA,EAAA,MAAA;EAAA,sBAAA,EAAA,MAAA;AAAA;;AAAA;;CAAA;;AAAA;;EAAA,eAAA;EAAA,YAAA;AAAA;;AAAA,wEAAA;AAAA;EAAA,aAAA;AAAA;EAAA;IAAA,qEAAA;IAAA,kBAAA;IAAA,wEAAA;IAAA,kEAAA;IAAA,kCAAA;IAAA,iFAAA;IAAA,uCAAA;IAAA,yEAAA;IAAA,sGAAA;IAAA,2BAAA;IAAA,mEAAA;IAAA;gIAAA;IAAA,gEAAA;IAAA,iEAAA;IAAA,+DAAA;IAAA,gEAAA;IAAA,iEAAA;IAAA,+DAAA;IAAA,kEAAA;IAAA,wCAAA;IAAA,qEAAA;IAAA,wEAAA;IAAA,kBAAA;IAAA,qCAAA;IAAA,mBAAA;IAAA,0BAAA;IAAA,6EAAA;IAAA,gDAAA;IAAA,4FAAA;IAAA,8GAAA;IAAA,sBAAA;IAAA,kBAAA;IAAA,sBAAA;IAAA,uDAAA;IAAA,4DAAA;IAAA,kEAAA;IAAA,6DAAA;IAAA,kDAAA;IAAA,+FAAA;IAAA,8CAAA;IAAA,oCAAA;EAAA;AACA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AACA;EAAA,kBAAA;EAAA,UAAA;EAAA,WAAA;EAAA,UAAA;EAAA,YAAA;EAAA,gBAAA;EAAA,sBAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,UAAA;EAAA;AAAA;AAAA;EAAA,SAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,mBAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,8DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yEAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,wEAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,yEAAA;EAAA,kEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,oEAAA;EAAA;AAAA;AAAA;EAAA,gEAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,mEAAA;EAAA;AAAA;AAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,qEAAA;EAAA;AAAA;AAAA;EAAA,sEAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,mDAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA,8CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,8CAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,oGAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,wCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,yGAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kGAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA;AAAA;AAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,0CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;EAmGE;IACE,mDAAA;IACA,sBAAA;IACA,kCAAA;IACA,4BAAA;IACA,kBAAA;IACA,aAAA;IACA,sBAAA;EApBF;EAyBI;IACE,wBAAA;EAvBN;EA2BE;IACE,eAAA;EAzBJ;EA2BI;IACE,wCAAA;IACA,iBAAA;IACA,gBAAA;IACA,kBAAA;EAzBN;EA2BM;IACE,qGAAA;EAzBR;EA4BM;IACE,qGAAA;EA1BR;EA6BM;IACE,qGAAA;EA3BR;EA8BM;IACE,oGAAA;EA5BR;EA+BM;IACE,qGAAA;EA7BR;EAgCM;IACE,sGAAA;EA9BR;EAiCM;IA9BF;MA+BI,eAAA;MACA,sCAAA;MACA,iBAAA;IA9BN;EACF;EAmCI;IACE,gEAAA;EAjCN;EAoCI;IACE,gEAAA;EAlCN;EAwCA;IACE,oBAAA;IACA,UAAA;IACA,SAAA;IACA,uBAAA;IACA,eAAA;IACA,cAAA;EAtCF;EAyCA;;IAEE,cAAA;IACA,8BAAA;IACA,WAAA;IACA,eAAA;EAvCF;EA0CA;IACE,kBAAA;IACA,wBAAA;IACA,2BAAA;IACA,4BAAA;IACA,WAAA;IACA,oBAAA;EAxCF;EA2CA;;IAEE,sBAAA;IACA,2BAAA;IACA,mCAAA;IACA,kBAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,mBAAA;IACA,kBAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;IACA,oDAAA;IACA,6BAAA;IACA,8BAAA;IACA,yBAAA;IACA,iDAAA;IACA,0BAAA;IACA,2BAAA;IACA,kBAAA;IACA,4BAAA;IACA,kBAAA;IACA,mBAAA;IACA,aAAA;IACA,2BAAA;EAzCF;EA2CE;;IACE,aAAA;EAxCJ;EA2CE;;IACE,aAAA;IACA,cAAA;IACA,cAAA;IACA,UAAA;IACA,cAAA;EAxCJ;EA2CE;;;;IAGE,gDAAA;IACA,8BAAA;IACA,aAAA;IACA,2BAAA;EAxCJ;EA4CA;IACE,oBAAA;IACA,cAAA;IACA,eAAA;EA1CF;EA4CE;IACE,aAAA;IACA,mBAAA;EA1CJ;EA8CA;IACE,2BAAA;IACA,mCAAA;IACA,oBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,oDAAA;IACA,6BAAA;IACA,8BAAA;IACA,yBAAA;IACA,2BAAA;EA5CF;EA8CE;IACE,aAAA;IACA,cAAA;EA5CJ;EAgDA;IACE,mDAAA;IACA,2DAAA;IACA,mEAAA;IACA,8BAAA;IACA,4BAAA;IACA,sBAAA;IACA,oBAAA;IACA,4BAAA;IACA,qBAAA;IACA,kBAAA;IACA,mBAAA;IAEA,sCAAA;EA/CF;EAiDE;IACE,WAAA;IACA,mDAAA;IACA,2DAAA;IACA,kBAAA;IACA,YAAA;IACA,WAAA;IACA,MAAA;IACA,OAAA;IACA,oBAAA;IACA,mGAAA;IACA,8BAAA;IACA,4BAAA;IACA,sBAAA;IACA,oBAAA;IACA,4BAAA;EA/CJ;EAkDE;IACE,mEAAA;EAhDJ;EAkDI;IACE,oEAAA;EAhDN;EAqDA;IACE,4BAAA;IACA,yBAAA;IACA,sBAAA;EAnDF;EAgDA;IACE,iBAAA;IACA,cAAA;IACA,WAAA;EAnDF;EAqDE;IALF;MAMI,0BAAA;IAlDF;IA4CF;MAMI,eAAA;IAlDF;EACF;AArRF;EAAA;AAAA;AAIA;EACE,uBAAA;EACA,oBAAA;EACA,sBAAA;AADF;;AAIA;EACE;IACE,sBAAA;EADF;AACF;AA4DA;EACE,sCAAA;AAZF;AA+QE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;AApDJ;AAwDI;EACE,mBAAA;EACA,2CAAA;EACA,yCAAA;EACA,mBAAA;EACA,uBAAA;AAtDN;AAyDI;EACE,4BAAA;EACA,2CAAA;EACA,wCAAA;EACA,mBAAA;EACA,uBAAA;AAvDN;AA2DE;EACE,aAAA;AAzDJ;AA4DE;EACE,qBAAA;EACA,gDAAA;AA1DJ;AA4DI;EACE,UAAA;EACA,WAAA;AA1DN;AA6DI;EACE,mCAAA;EACA,qBAAA;AA3DN;AA8DI;EACE,mEAAA;EACA,qBAAA;AA5DN;AA+DI;EACE,mEAAA;AA7DN;AAiEE;EAEE,4DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAhEJ;AAkEI;EAbF;IAcI,eAAA;EA/DJ;AACF;AAiEI;EAjBF;IAkBI,eAAA;EA9DJ;AACF;;AAqKA;EA/FE;;IAEE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,0BAAA;IACA,4BAAA;IACA,mBAAA;EAlEF;EAqEA;IACE,WAAA;EAnEF;EAsEA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EApEF;EAuEA;;;IAGE,WAAA;IACA,YAAA;EArEF;EAwEA;IACE,QAAA;EAtEF;AACF;AA8IA;EACE;IArEA,uBAAA;IACA,mBAAA;IACA,qBAAA;IACA,4BAAA;IACA,6BAAA;IACA,8BAAA;EAtEA;EAgCA;;IAEE,YAAA;IACA,gBAAA;IACA,gBAAA;IACA,0BAAA;IACA,4BAAA;IACA,mBAAA;EA9BF;EAiCA;IACE,WAAA;EA/BF;EAkCA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;EAhCF;EAmCA;;;IAGE,WAAA;IACA,YAAA;EAjCF;EAoCA;IACE,QAAA;EAlCF;EA8CA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;EA5CF;EA+CA;IACE,mBAAA;IACA,QAAA;IACA,YAAA;EA7CF;EAgDA;IACE,0BAAA;EA9CF;EAiDA;IACE,mBAAA;IACA,yBAAA;IACA,iBAAA;EA/CF;EAoDA;IACE,gBAAA;IACA,mBAAA;EAlDF;EAqDA;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;EAnDF;EAsDA;IACE,2BAAA;IACA,mBAAA;EApDF;EAuDA;IACE,iBAAA;EArDF;EAuDE;IACE,YAAA;IACA,2BAAA;IACA,iBAAA;IACA,kBAAA;IACA,0BAAA;IACA,4BAAA;EArDJ;AACF;AAsEA;EACE;IA5EA,uBAAA;IACA,mBAAA;IACA,qBAAA;IACA,4BAAA;IACA,6BAAA;IACA,8BAAA;EASA;EAPA;IACE,WAAA;IACA,YAAA;IACA,gBAAA;IACA,eAAA;EASF;EANA;IACE,mBAAA;IACA,QAAA;IACA,YAAA;EAQF;EALA;IACE,0BAAA;EAOF;EAJA;IACE,mBAAA;IACA,yBAAA;IACA,iBAAA;EAMF;EADA;IACE,gBAAA;IACA,mBAAA;EAGF;EAAA;IACE,sBAAA;IACA,oBAAA;IACA,qBAAA;EAEF;EACA;IACE,2BAAA;IACA,mBAAA;EACF;EAEA;IACE,iBAAA;EAAF;EAEE;IACE,YAAA;IACA,2BAAA;IACA,iBAAA;IACA,kBAAA;IACA,0BAAA;IACA,4BAAA;EAAJ;AACF;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA,sBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,sBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,oBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,oBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,oBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA,sBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,8BAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA,yBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;AAAA;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,+BAyfR;IAzfQ;EAyfR;AAAA;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,sBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,iBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,iBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,eAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,iBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,eAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,gDAyfR;IAzfQ,6DAyfR;IAzfQ;EAyfR;AAAA;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,eAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;MAAA;IAyfR;IAzfQ;MAAA,qBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,mBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,mBAyfR;MAzfQ;IAyfR;EAAA;AAAA;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,gBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,eAyfR;IAzfQ,eAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,sBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,iBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,iBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,eAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;AAAA;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,oBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,qBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,eAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,mBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,kBAyfR;IAzfQ;EAyfR;AAAA;AAzfQ;EAAA;IAAA;MAAA;IAyfR;IAzfQ;MAAA,oBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,oBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA,sBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,sBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,oBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,sBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,qBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,kBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,oBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,qBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,mBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,qBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,iBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA,8BAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,8BAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,iBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,kBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA,eAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,mBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA,kBAyfR;MAzfQ;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;EAAA;AAAA;AAzfQ;EAAA;IAAA;MAAA;IAyfR;EAAA;AAAA;AAzfQ;EAAA;IAAA;MAAA;QAAA;MAyfR;MAzfQ;QAAA,mBAyfR;QAzfQ;MAyfR;IAAA;EAAA;AAAA;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA,kBAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;AAAA;AAzfQ;EAAA;IAAA;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;EAAA;AAAA;AAzfQ;EAAA,iCAyfR;EAzfQ;AAyfR;AAzfQ;EAAA,+BAyfR;EAzfQ;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;AAyfR;AAzfQ;EAAA;IAAA;MAAA;IAyfR;IAzfQ;MAAA;IAyfR;EAAA;AAAA;AAzfQ;EAAA;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,iCAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,gCAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA;EAyfR;EAzfQ;IAAA,8BAyfR;IAzfQ;EAyfR;EAzfQ;IAAA,6BAyfR;IAzfQ;EAyfR;EAzfQ;IAAA;EAyfR;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&family=Plus+Jakarta+Sans:wght@500;600;700&display=swap');\n\n\n:root {\n  --ufe-logo-height: 28px;\n  --ufe-logo-top: 32px;\n  --ufe-logo-inset: 64px;\n}\n\n@media (max-width: 767.98px) {\n  :root {\n    --ufe-logo-inset: 20px;\n  }\n}\n\n@layer base {\n  :root {\n    --sidebar-bg: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);\n    --logo-bg: #04102B;\n    --text-bg: linear-gradient(90deg, #A5A5A5 0%, #C8C7C7 50%, #A5A5A5 100%);\n    --timerBg: linear-gradient(180deg, #0E0F24 -1.96%, #161843 96.08%);\n    --footerBg: rgba(19, 10, 36, 0.45);\n    --sliderBg: linear-gradient(180deg, #B74ADE -34.9%, rgba(129, 48, 255, 0) 159.9%);\n    --footerBorder: rgba(123, 44, 255, 0.2);\n    --sidebarBorder: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);\n    --timerBorder: linear-gradient(180deg, rgba(2, 97, 172, 0.2) -1.96%, rgba(129, 205, 246, 0.2) 103.92%);\n    --sliderBorder: transparent;\n    --rangeButton: linear-gradient(180deg, #3D0651 1.2%, #B84AE0 96.2%);\n    --sliderWrapperBg: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 14.06%, rgba(0, 0, 0, 0) 85.94%, rgba(0, 0, 0, 0.6) 100%),\n      linear-gradient(90deg, rgba(255, 255, 255, 0.01) 9.9%, rgba(255, 255, 255, 0.15) 51.04%, rgba(255, 255, 255, 0.01) 89.58%);\n    --foldButtonBg: linear-gradient(90deg, #4C1D95 0%, #C026D3 100%);\n    --checkButtonBg: linear-gradient(90deg, #5A3412 0%, #F4B942 100%);\n    --BetButtonBg: linear-gradient(90deg, #2E1065 0%, #8B5CF6 100%);\n    --callButtonBg: linear-gradient(90deg, #052E16 0%, #22C55E 100%);\n    --raiseButtonBg: linear-gradient(90deg, #0B3A5B 0%, #38BDF8 100%);\n    --allButtonBg: linear-gradient(90deg, #1E1B4B 0%, #818CF8 100%);\n    --modalBg: linear-gradient(180deg, #0E0F31 49.51%, #161843 98.06%);\n    --toggleBgOff: rgba(255, 255, 255, 0.24);\n    --toggleBgOn: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);\n    --toggleBorder: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);\n    --tableBg: #040D20;\n    --tableBorder: rgba(14, 89, 148, 0.4);\n    --filterBg: #060822;\n    --filterWrapperBg: #161843;\n    --inputCheckButtonBg: linear-gradient(180deg, #045E8B -1.96%, #002D51 96.08%);\n    --tournamentBorderColor: rgba(24, 188, 238, 0.2);\n    --tournamentPodiumFrontCardBg: linear-gradient(180deg, #7B2CFF 0%, rgba(19, 10, 36, 0) 100%);\n    --tournamentPodiumTopCardBg: linear-gradient(0deg, rgba(123, 44, 255, 0.75) 0%, rgba(123, 44, 255, 0.08) 100%);\n    ;\n\n\n\n    --modalBorder: #0D2B4D;\n    --buyWith: #060822;\n    --buyWithText: #A2A2A2;\n    --modalBgImage: url('../src/assets/images/poker/modal-bg-image.png');\n    --tournamentBgImage: url('../src/assets/images/poker/tournaments/top-tournament-bg.png');\n    --tournamentMobileBgImage: url('../src/assets/images/poker/tournaments/top-tournament-mobile-bg.png');\n    --leaderboardBgImage: url('../src/assets/images/poker/tournaments/leaderboard-bg.png');\n\n\n\n    // Box Shadow variables\n    --sliderShadow: 0px 0px 5.39px 0px #FFFFFFCC inset;\n    --actionButtonshadow: 0px 0px 8px 0px rgba(192, 38, 211, 0.4), 0px 7px 10px 0px #FFFFFF4D inset;\n    --buyWithShadow: 0px 2px 4px 0px #030415 inset;\n    --trophyDropShadow: 0 0 40px #18BCEE;\n\n  }\n}\n\n* {\n  font-family: \"Nunito Sans\", sans-serif;\n}\n\n@layer components {\n  input[type=\"checkbox\"]:checked+.toggle-button {\n    &::after {\n      content: \"\";\n      position: absolute;\n      inset: 0;\n      padding: 1px;\n      border-radius: 16px;\n      background: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);\n      -webkit-mask:\n        linear-gradient(#000 0 0) content-box,\n        linear-gradient(#000 0 0);\n      -webkit-mask-composite: xor;\n\n      mask:\n        linear-gradient(#000 0 0) content-box,\n        linear-gradient(#000 0 0);\n      mask-composite: exclude;\n    }\n  }\n}\n\n@layer utilities {\n  body {\n    background: url('../src/assets/images/poker/game-bg.png');\n    background-size: cover;\n    background-position: center center;\n    background-repeat: no-repeat;\n    min-height: 100dvh;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .footer-section {\n    .timer {\n      button {\n        font-family: Nunito Sans;\n      }\n    }\n\n    .button-group {\n      flex-wrap: wrap;\n\n      button {\n        font-size: clamp(14px, 1.093dvw, 1.1rem);\n        line-height: 22px;\n        min-width: 140px;\n        width: fit-content;\n\n        &.bg-foldButtonBg {\n          box-shadow: 0px 0px 8px rgba(192, 38, 211, 0.4), inset 0px 7px 10px #FFFFFF4D;\n        }\n\n        &.bg-checkButtonBg {\n          box-shadow: 0px 0px 8px rgba(244, 185, 66, 0.4), inset 0px 7px 10px #FFFFFF4D;\n        }\n\n        &.bg-BetButtonBg {\n          box-shadow: 0px 0px 8px rgba(139, 92, 246, 0.4), inset 0px 7px 10px #FFFFFF4D;\n        }\n\n        &.bg-callButtonBg {\n          box-shadow: 0px 0px 8px rgba(34, 197, 94, 0.4), inset 0px 7px 10px #FFFFFF4D;\n        }\n\n        &.bg-raiseButtonBg {\n          box-shadow: 0px 0px 8px rgba(56, 189, 248, 0.4), inset 0px 7px 10px #FFFFFF4D;\n        }\n\n        &.bg-allButtonBg {\n          box-shadow: 0px 0px 8px rgba(129, 140, 248, 0.4), inset 0px 7px 10px #FFFFFF4D;\n        }\n\n        @media screen and (max-width: 1024px) {\n          min-width: 84px;\n          font-size: clamp(12px, 1.093dvw, 14px);\n          line-height: 14px;\n        }\n      }\n    }\n\n    .range-slider-input.slider {\n      &::-webkit-slider-thumb {\n        background: linear-gradient(180deg, #3D0651 1.2%, #B84AE0 96.2%);\n      }\n\n      &::-moz-range-thumb {\n        background: linear-gradient(180deg, #3D0651 1.2%, #B84AE0 96.2%);\n      }\n    }\n  }\n\n\n  .landing-logo-btn {\n    display: inline-flex;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    cursor: pointer;\n    line-height: 0;\n  }\n\n  .landing-logo-btn img,\n  .game-rules-header__logo {\n    display: block;\n    height: var(--ufe-logo-height);\n    width: auto;\n    max-width: none;\n  }\n\n  .ufe-game-header {\n    position: absolute;\n    top: var(--ufe-logo-top);\n    left: var(--ufe-logo-inset);\n    right: var(--ufe-logo-inset);\n    z-index: 10;\n    pointer-events: none;\n  }\n\n  .leave-table-btn,\n  .v2-exit-table {\n    box-sizing: border-box;\n    mask-image: none !important;\n    -webkit-mask-image: none !important;\n    aspect-ratio: auto;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    gap: 6px !important;\n    position: relative;\n    height: 45px;\n    min-height: 45px;\n    padding: 8px 16px;\n    border: 1px solid rgba(123, 44, 255, 0.2) !important;\n    border-radius: 6px !important;\n    background: #130a24 !important;\n    color: #ffffff !important;\n    font-family: \"Nunito Sans\", sans-serif !important;\n    font-size: 13px !important;\n    font-weight: 700 !important;\n    font-style: normal;\n    line-height: 18px !important;\n    word-break: normal;\n    white-space: nowrap;\n    outline: none;\n    box-shadow: none !important;\n\n    &:before {\n      display: none;\n    }\n\n    svg {\n      width: 13.5px;\n      height: 13.5px;\n      display: block;\n      flex: none;\n      color: #ffffff;\n    }\n\n    &:hover,\n    &:focus,\n    &:active {\n      border-color: rgba(123, 44, 255, 0.2) !important;\n      background: #130a24 !important;\n      outline: none;\n      box-shadow: none !important;\n    }\n  }\n\n  .v2-exit-table {\n    display: inline-flex;\n    width: 111.5px;\n    cursor: pointer;\n\n    &:disabled {\n      opacity: 0.45;\n      cursor: not-allowed;\n    }\n  }\n\n  .v2-music-btn {\n    mask-image: none !important;\n    -webkit-mask-image: none !important;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 45px;\n    height: 45px;\n    min-height: 45px;\n    padding: 0;\n    border: 1px solid rgba(123, 44, 255, 0.2) !important;\n    border-radius: 6px !important;\n    background: #130a24 !important;\n    color: #ffffff !important;\n    box-shadow: none !important;\n\n    svg {\n      width: 13.5px;\n      height: 13.5px;\n    }\n  }\n\n  .action-btn {\n    mask-image: url('./assets/images/poker/button-bg.svg');\n    -webkit-mask-image: url('./assets/images/poker/button-bg.svg');\n    background: linear-gradient(180deg, #0E0F24 -1.96%, #161843 96.08%);\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-size: 100% 100%;\n    mask-repeat: no-repeat;\n    mask-size: 100% 100%;\n    background-clip: padding-box;\n    word-break: break-all;\n    position: relative;\n    aspect-ratio: 48/17;\n    // min-width: 11.765dvw;\n    font-size: clamp(12px, 1.093dvw, 16px);\n\n    &:before {\n      content: '';\n      mask-image: url('./assets/images/poker/btn-border.svg');\n      -webkit-mask-image: url('./assets/images/poker/btn-border.svg');\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0;\n      left: 0;\n      pointer-events: none;\n      background: linear-gradient(180deg, rgba(2, 97, 172, 0.2) -1.96%, rgba(129, 205, 246, 0.2) 103.92%);\n      -webkit-mask-repeat: no-repeat;\n      -webkit-mask-size: 100% 100%;\n      mask-repeat: no-repeat;\n      mask-size: 100% 100%;\n      background-clip: padding-box;\n    }\n\n    &:nth-child(1) {\n      background: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);\n\n      &:before {\n        background: linear-gradient(180deg, #0B5691 -1.96%, #81CDF6 103.92%);\n      }\n    }\n  }\n\n  .container {\n    max-width: 1716px;\n    margin: 0 auto;\n    width: 100%;\n\n    @media screen and (max-width: 767px) {\n      max-width: 100%;\n    }\n  }\n}\n\nbody {\n  #root {\n    height: 100dvh;\n    min-height: 100dvh;\n    max-height: 100dvh;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n  }\n\n  .Toastify__toast-theme--colored {\n    &.Toastify__toast--success {\n      background: #04102B;\n      box-shadow: 0px -1px 11px 0px #2883C8 inset;\n      border: 1px solid rgba(40, 131, 200, 0.6);\n      border-radius: 1rem;\n      padding-left: 1.3125rem;\n    }\n\n    &.Toastify__toast--error {\n      background: rgba(193, 43, 52, 1);\n      box-shadow: 0px -1px 11px 0px #C12B34 inset;\n      border: 1px solid #C12B3499;\n      border-radius: 1rem;\n      padding-left: 1.3125rem;\n    }\n  }\n\n  .Toastify__close-button--colored {\n    display: none;\n  }\n\n  .themed-scrollbar {\n    scrollbar-width: thin;\n    scrollbar-color: #2570AE rgba(14, 89, 148, 0.18);\n\n    &::-webkit-scrollbar {\n      width: 6px;\n      height: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background: rgba(14, 89, 148, 0.18);\n      border-radius: 9999px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background: linear-gradient(180deg, #65BCE7 -1.96%, #2570AE 96.08%);\n      border-radius: 9999px;\n    }\n\n    &::-webkit-scrollbar-thumb:hover {\n      background: linear-gradient(180deg, #81CDF6 -1.96%, #0B5691 96.08%);\n    }\n  }\n\n  .modal-heading {\n\n    background: linear-gradient(90deg, #FFFFFF 0%, #999999 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n    color: transparent;\n    -webkit-text-stroke: 0.4px #DEDEDE;\n    text-stroke: 0.4px #DEDEDE;\n    font-size: 36px;\n    font-weight: 400;\n    line-height: normal;\n\n    @media screen and (max-width: 1024px) {\n      font-size: 22px;\n    }\n\n    @media screen and (max-width: 1279px) and (orientation: landscape) {\n      font-size: 18px;\n    }\n  }\n}\n\n// Short or narrow gameplay viewports (phone landscape, and Chrome responsive\n// sizes such as 1087×488). A wide-but-short frame still uses the desktop\n// header unless height is included. Tall desktop windows are unchanged.\n@mixin ufe-game-compact-controls {\n  .leave-table-btn,\n  .v2-exit-table {\n    height: 26px;\n    min-height: 26px;\n    padding: 2px 8px;\n    font-size: 11px !important;\n    line-height: 14px !important;\n    gap: 4px !important;\n  }\n\n  .v2-exit-table {\n    width: auto;\n  }\n\n  .v2-music-btn {\n    width: 26px;\n    height: 26px;\n    min-height: 26px;\n  }\n\n  .leave-table-btn svg,\n  .v2-exit-table svg,\n  .v2-music-btn svg {\n    width: 12px;\n    height: 12px;\n  }\n\n  .ufe-game-header .gap-4 {\n    gap: 6px;\n  }\n}\n\n@mixin ufe-game-short-layout {\n  --ufe-logo-height: 18px;\n  --ufe-logo-top: 6px;\n  --ufe-logo-inset: 8px;\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n  padding-bottom: 8px !important;\n\n  .landing-logo-btn img {\n    width: auto;\n    height: auto;\n    max-height: 18px;\n    max-width: 96px;\n  }\n\n  .ufe-game-header .pointer-events-auto > .flex {\n    align-items: center;\n    gap: 4px;\n    min-width: 0;\n  }\n\n  .ufe-game-header .top-full {\n    margin-top: 2px !important;\n  }\n\n  .ufe-pool-details {\n    gap: 3px !important;\n    font-size: 8px !important;\n    line-height: 1.15;\n  }\n\n  // Keep the felt between the header and the action bar, same as the\n  // Maldives table top offset, so the dealer is not covered.\n  #pixi-container {\n    margin-top: 36px;\n    margin-bottom: 52px;\n  }\n\n  > .absolute {\n    bottom: 6px !important;\n    left: 8px !important;\n    right: 8px !important;\n  }\n\n  .footer-section {\n    padding: 4px 6px !important;\n    gap: 6px !important;\n  }\n\n  .footer-section .button-group {\n    flex-wrap: nowrap;\n\n    button {\n      min-width: 0;\n      min-height: 32px !important;\n      padding-left: 8px;\n      padding-right: 8px;\n      font-size: 12px !important;\n      line-height: 14px !important;\n    }\n  }\n}\n\n@media screen and (max-width: 1023px) {\n  .ufe-game-shell {\n    @include ufe-game-compact-controls;\n  }\n}\n\n@media screen and (max-height: 560px) {\n  .ufe-game-shell {\n    @include ufe-game-compact-controls;\n    @include ufe-game-short-layout;\n  }\n}\n\n@media screen and (max-width: 767.98px) {\n  .ufe-game-shell {\n    @include ufe-game-short-layout;\n  }\n}\n\n// aspect-ratio: 216 / 65;\n// padding: 0;\n// min-width: 11.25dvw;\n// width: 100%;\n// font-size: clamp(16px, 1.093dvw, 21px);\n\n\n// aspect-ratio: 156 / 51;\n// padding: 0;\n// min-width: 8.125dvw;\n// width: 100%;\n// font-size: clamp(16px, 1.093dvw, 21px);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
